const canvas = document.getElementById('captureCanvas');
const ctx = canvas.getContext('2d', {
    alpha: false
});

let stream = null;
let videoElement = null;
let lastImageData = null;

let firstCapture = true;
window.successDetected = false;

let rmsSessionDetails = {
    sessionCreator: null,
    sessionExpiresAt: null,
    hasShownSessionCreator: false,
}

const RMS = {
    droidQueue: null,
    datachip: null,
    currentContainer: null,
    resources: [],
    marketPrices: {},
    typePrices: {},
    marketPricesLoaded: false,
    scanMode: 'full',
    scannerProvider: null,
    lastPropertyCrop: null,
    maxQueueSize: 10, // Adjust as needed
    init: async function(droidQueue, datachip) {
        this.droidQueue = droidQueue;
        this.datachip = datachip;

        // Check if this is a lifeday/competition page
        const isLifeday = window.location.pathname.startsWith("/lifeday");
        
        // Handle minimal datachip objects (e.g., competition token)
        const isMinimalDatachip = !datachip.datachip_id && !datachip.id && datachip.token;

        // Use datachip_id consistently (this is what the server expects)
        const containerId = datachip.datachip_id || datachip.id || (isMinimalDatachip ? 'competition' : null);

        //default container is the datachips id
        this.currentContainer = {
            id: containerId,
            name: datachip.name || (isMinimalDatachip ? 'Competition' : 'Unknown'),
            items: [],
            resources: []
        }
        
        const datachipName = this.datachip.name || (isMinimalDatachip ? 'Competition' : 'Unknown');
        console.log(`RMS (${datachipName}) initialized with container ${containerId}`);
        window.RMS = this;

        // Update container indicator on init (only if elements exist)
        this.updateContainerIndicator();

        // Skip resource fetching on lifeday page or for minimal datachip objects
        if (!isLifeday && !isMinimalDatachip) {
            await this.updateResourcesFromServer();
        }
        return this;
    },
    getToken: function() {
        console.log("DEBUG: getToken, RMS.datachip.token: ", RMS.datachip);
        return RMS.datachip.token;
    },
    setToken: function(token) {
        RMS.datachip.token = token;
    },
    refreshToken: async function() {
        const accessCode = RMS.datachip?.usedAccessCode;
        if (!accessCode) return false;
        try {
            const response = await fetch('/api/auth', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ accessCode })
            });
            const data = await response.json();
            if (!data.success || !data.token) return false;

            RMS.datachip.token = data.token;

            const known = JSON.parse(localStorage.getItem('knownDatachips')) || [];
            const found = known.find(dc => dc.serialNumber === RMS.datachip.serialNumber);
            if (found) {
                found.token = data.token;
                localStorage.setItem('knownDatachips', JSON.stringify(known));
            }

            if (typeof CaptureManager !== 'undefined' && CaptureManager?.setToken) {
                CaptureManager.setToken(data.token);
            }
            return true;
        } catch (e) {
            console.error('refreshToken failed:', e);
            return false;
        }
    },
    isLifeday: function() {
        return window.location.pathname.startsWith("/lifeday");
    },
    updateContainerIndicator: function() {
        // Check if we're on lifeday page - container indicator doesn't exist there
        const isLifeday = window.location.pathname.startsWith("/lifeday");
        if (isLifeday) {
            return; // Skip container indicator updates on lifeday page
        }

        const nameEl = document.getElementById('current-container-name');
        const countEl = document.getElementById('container-resource-count');

        if (nameEl && this.currentContainer) {
            nameEl.textContent = this.currentContainer.name || 'Unknown';
        }

        if (countEl) {
            const count = this.resources?.length || 0;
            countEl.textContent = `${count} resource${count !== 1 ? 's' : ''}`;
        }
    },
    fetchMarketPrices: async function() {
        if (this.marketPricesLoaded) return;
        try {
            const response = await fetch('/api/auction/market-prices');
            const data = await response.json();
            if (data.success) {
                this.marketPrices = data.prices;
                this.typePrices = data.typePrices || {};
                this.marketPricesLoaded = true;
            }
        } catch (error) {
            console.error('Error fetching market prices:', error);
        }
    },
    updateResourcesFromServer: async function() {
        var vm = RMS;
        
        // Skip resource fetching on lifeday page or for minimal datachip objects
        const isLifeday = window.location.pathname.startsWith("/lifeday");
        const isMinimalDatachip = !vm.datachip.datachip_id && !vm.datachip.id && vm.datachip.token;
        
        if (isLifeday || isMinimalDatachip) {
            return; // Don't fetch resources for competition/lifeday pages
        }
        
        try {

            let container_id = vm.datachip.datachip_id;
            if(vm.currentContainer && vm.currentContainer.id != null)
                container_id = vm.currentContainer.id;

            console.log("DEBUG: updateResourcesFromServer, container_id: ", container_id, vm, vm.datachip.id);
            const response = await fetch('/api/datachip/resources?' + new URLSearchParams({
                container_id: container_id
            }), {
                headers: {
                    'Authorization': `Bearer ${vm.getToken()}`
                }
            });

            if (!response.ok) throw new Error('Failed to fetch resources');

            const data = await response.json();
            if (data.success) {
                // Store resources (single source of truth)
                vm.resources = data.resources;

                // Ensure market prices are loaded before rendering
                await vm.fetchMarketPrices();

                // Clear existing table
                const tbody = document.querySelector('#resource-table tbody');
                tbody.innerHTML = '';

                // Add each resource to the table
                vm.resources.forEach(resource => {
                    vm.addResourceToTable(resource, "from-server");
                });

                // Update the container indicator
                vm.updateContainerIndicator();
            }
        } catch (error) {
            console.error('Error updating resources:', error);
        }
    },
    updateQuickActions: function(context) {
        var vm = RMS;
        const actionsArea = document.getElementById('quick-actions-area');
        actionsArea.innerHTML = ''; // Clear existing actions
        actionsArea.style.display = 'flex';
    
        console.log("DEBUG: updateQuickActions", context);
        
        const actions = vm.getContextActions(context);
        actions.forEach((action, index) => {
            const button = document.createElement('button');
            // Add base classes
            button.className = 'quick-action-button border px-4 py-2 rounded transition-all duration-300';
            
            // Add state-specific classes
            if (action.isActive) {
                // Active state: stronger colors and glow effect
                button.classList.add(
                    'border-terminal-green',
                    'bg-terminal-green/30',
                    'hover:bg-terminal-green/40',
                    'shadow-terminal'
                );
            } else {
                // Inactive state: dimmed appearance
                button.classList.add(
                    'border-terminal-green/30',
                    'hover:border-terminal-green',
                    'hover:bg-terminal-green/20'
                );
            }
            
            // Add delay based on index
            button.style.animationDelay = `${index * 150}ms`;
            button.textContent = action.label;
            if (action.label.includes('\n')) {
                button.style.whiteSpace = 'pre-line';
                button.style.wordSpacing = 'normal';
            }
            button.onclick = action.onClick;
            actionsArea.appendChild(button);
        });
    
    
        if(actions.length == 0){
            console.log("DEBUG: updateQuickActions, no actions found, hiding quick actions area");
            actionsArea.style.display = 'none';
        }
    },
    getContextActions: function(context) {
        const isLifeday = window.location.pathname.startsWith("/lifeday");
        const actions = [];

        if (window.Commands?.active && !isLifeday && RMS.datachip) {
            return this.getCommandModeActions(context);
        }

        const isTableVisible =  context == 'viewing-table' || document.getElementById('data-table-container').classList.contains('visible');
        console.log("DEBUG: isTableVisible", isTableVisible, "context: ", context);
        
        // Base view resources action
        if(RMS.datachip && !isLifeday){
            actions.push({
                label: isTableVisible ? 'Hide Resources' : 'View Resources',
                onClick: () => { 
                    toggleResourceTable(); 
                },
                isActive: isTableVisible
            });
        }

        if(context == 'unauthed-home' || context == 'lifeday'){
            document.getElementById('additional-area').style.display = 'block';
        } else {
            document.getElementById('additional-area').style.display = 'none';
            let unauthedHomeSection = document.getElementById('unauthed-home-section');
            if(unauthedHomeSection){
                unauthedHomeSection.style.display = 'none';
            }
        }
    
    
        switch(context) {
            case 'monitoring':

                actions.push({
                    label: 'End Session',
                    // Wrap so the click event isn't forwarded as `fromIssue` (which would force the failure ending).
                    onClick: () => endMonitoringSession()
                });


                if(isLifeday){
                    actions.push({
                        label: 'Submit New Entry',
                        onClick: preCaptureSequence
                    });
                    actions.push({
                        label: 'About C14-RMS',
                        onClick: getLifedayWP
                    });
                } else {
                    actions.push({
                        label: 'Change Container',
                        onClick: showAndSelectContainerModal
                    });
                    // Add Execute Command action during monitoring
                    if (window.Commands) {
                        actions.push({
                            label: 'Execute Command',
                            onClick: () => window.Commands.enter()
                        });
                    }
                    if (window.CaptureManager?.monitoringInterval) {
                        actions.push({
                            label: RMS.scanMode === 'stock' ? 'Stock Mode: ON' : 'Stock Update Mode',
                            onClick: () => RMS.toggleStockMode(),
                            isActive: RMS.scanMode === 'stock'
                        });
                    }
                }
                break;
            case 'lifeday':
                
    
                if(localStorage.getItem('lifeday-user')){
                    actions.push({
                        label: 'Submit New Entry',
                        onClick: preCaptureSequence
                    });
                    actions.push({
                        label: 'Get /way for C14-RMS Droid Purchase',
                        onClick: getLifedayWP
                    });
                    actions.push({
                        label: 'Remove Datachip (Logout)',
                        onClick: () => {
                            localStorage.removeItem('lifeday-user');
                            localStorage.removeItem('lifeday-token');
                            window.location.href = '/lifeday';
                        }
                    });
                } else {
                    actions.push({
                        label: 'About C14-RMS',
                        onClick: getLifedayWP
                    });
                }
    
                if(localStorage.getItem('knownDatachips')){
                    actions.push({
                        label: 'Goto C14-RMS Droid',
                        onClick: () => {
                            window.location.href = '/';
                        }
                    });
                } else {
                    document.getElementById('c14-pro').style.display = 'block';
                }
                break;
            case 'home':
                if (localStorage.getItem('isOwner') === 'true') {
                    actions.push({
                        label: 'Manage Containers',
                        onClick: () => { showAndSelectContainerModal(); }
                    });
                }
                // Add Resource Viewer action
                actions.push({
                    label: 'Resource Browser',
                    onClick: () => window.open('/resource-viewer', '_self')
                });
                actions.push({
                    label: 'Schematics Viewer',
                    onClick: () => window.open('/schematics-viewer', '_self')
                });
                // Add Execute Command action
                if (window.Commands) {
                    actions.push({
                        label: 'Execute Command',
                        onClick: () => window.Commands.enter()
                    });
                }
                // Show switch datachip if there are other known datachips
                const knownChips = JSON.parse(localStorage.getItem('knownDatachips')) || [];
                if (knownChips.length > 1) {
                    actions.push({
                        label: 'Switch Datachip',
                        onClick: () => {
                            // Hide table and show datachip selection
                            document.getElementById('data-table-container').style.display = 'none';
                            document.getElementById('data-table-container').classList.remove('visible');
                            RMS.updateQuickActions('pre-auth');
                        }
                    });
                }
                actions.push({
                    label: 'Eject Datachip',
                    onClick: () => {
                        // Remove current datachip from known datachips
                        const currentSerial = RMS.datachip?.serialNumber;
                        if (currentSerial) {
                            let knownDatachips = JSON.parse(localStorage.getItem('knownDatachips')) || [];
                            knownDatachips = knownDatachips.filter(dc => dc.serialNumber !== currentSerial);
                            localStorage.setItem('knownDatachips', JSON.stringify(knownDatachips));
                        }
                        // Clear other session data
                        localStorage.removeItem('isOwner');
                        RMS.datachip = null;
                        document.getElementById('data-table-container').style.display = 'none';
                        document.getElementById('data-table-container').classList.remove('visible');
                        document.getElementById('quick-actions-area').style.display = 'none';
                        window.location.reload();
                    }
                });
                break;
            case 'viewing-table':
                // Add owner-specific actions for viewing mode
                actions.push({
                    label: 'Start Capture',
                    onClick: startCaptureSequence
                });
                // Add Execute Command action
                if (window.Commands) {
                    actions.push({
                        label: 'Execute Command',
                        onClick: () => window.Commands.enter()
                    });
                }
                // Add Resource Viewer action
                actions.push({
                        label: 'Resource Browser',
                        onClick: () => window.open('/resource-viewer', '_self')
                    });
                actions.push({
                    label: 'Schematics Viewer',
                    onClick: () => window.open('/schematics-viewer', '_self')
                });
                break;
            case 'pre-auth':
                const knownDatachips = JSON.parse(localStorage.getItem('knownDatachips')) || [];
                knownDatachips.forEach(datachip => {
                    actions.push({
                        label: datachip.name,
                        onClick: () =>  {
                            const actionsArea = document.getElementById('quick-actions-area');
                            actionsArea.style.display = 'none';
                            loadDatachip(datachip, true);
                        }
                    });
                });
    
                break;
            default:
                break;
        }
    
    
        if(isLifeday){
            return actions;
        }

        if (RMS.datachip && !isTableVisible) {
            actions.push({
                label: 'Add to\nyour agent',
                onClick: () => showAgentModal()
            });
        }
    
        if (RMS.datachip && RMS.datachip.isOwner) {
            //actions.push({
            //    label: 'Settings',
            //    onClick: () => { console.log("Settings NOT IMPLEMENTED"); }// showSettingsModal
            //});
        }
        
        return actions;
    },
    getCommandModeActions: function(context) {
        const actions = [];

        actions.push({
            label: 'Close Console',
            onClick: () => window.Commands.exit(),
            isActive: true
        });

        actions.push({
            label: 'Resource Browser',
            onClick: () => window.open('/resource-viewer', '_self')
        });
        actions.push({
            label: 'Schematics Viewer',
            onClick: () => window.open('/schematics-viewer', '_self')
        });

        if (context === 'monitoring') {
            actions.push({
                label: 'End Session',
                onClick: () => endMonitoringSession()
            });
            actions.push({
                label: 'Change Container',
                onClick: showAndSelectContainerModal
            });
            if (window.CaptureManager?.monitoringInterval) {
                actions.push({
                    label: RMS.scanMode === 'stock' ? 'Stock Mode: ON' : 'Stock Update Mode',
                    onClick: () => RMS.toggleStockMode(),
                    isActive: RMS.scanMode === 'stock'
                });
            }
        } else if (context === 'viewing-table') {
            actions.push({
                label: 'Start Capture',
                onClick: startCaptureSequence
            });
        }

        return actions;
    },
    clearContainerResources: async function() {
        const resourceCount = this.resources.length;
        const confirmed = await new Promise(resolve => {
            this.droidQueue.clear()
                .eye([255, 165, 0], 'pulseEye', 1500)
                .text(`*warning beeps* Clear all ${resourceCount} resources from "${this.currentContainer.name}"?`, 2)
                .button("Yes, Clear", () => {
                    this.droidQueue.clear()
                        .eye([0, 255, 0], 'blinkEye', 1000)
                        .text(`*confirmatory beeps* "${this.currentContainer.name}" cleared.`, 1.5);
                    resolve(true);
                })
                .button("Cancel", () => {
                    this.droidQueue.clear()
                        .eye([255, 255, 255], 'blinkEye', 1000)
                        .text("*understanding beeps* Cancelled.", 1);
                    resolve(false);
                });
        });

        if (!confirmed) return;

        try {
            const response = await fetch('/api/datachip/resources/bulk-clear', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.getToken()}`
                },
                body: JSON.stringify({ container_id: this.currentContainer.id })
            });
            if (!response.ok) throw new Error('Failed to clear container resources');
            const data = await response.json();
            if (data.success) {
                this.currentContainer.resources = [];
                this.updateResourcesFromServer();
            }
        } catch (error) {
            console.error('Error clearing container resources:', error);
        }
    },
    startScreenCapture: async () => {
        RMS.updateQuickActions('monitoring');
        try {
            await CaptureManager.startCapture();
        } catch (error) {
            RMS.droidQueue
                .eye([255, 0, 0], 'strobeEye', 800)
                .text(`*worried beeps* ${error}`, 2)
                .wait(2000)
                .button("Try Again", RMS.startScreenCapture);
            return;
        }
        RMS.startWarmupHeartbeat(); // keep the GPU warm through idle gaps for the whole session
        fetch('/api/capture/session', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${RMS.getToken()}` }
        }).catch(() => {});
        window.postCaptureSequence();
    },
    findAndSetInventoryPropertyBox: async function(doBetterNameDetection = false) {
        firstCapture = true;
        let propertyBox = null;
        let characterName = null;
        let compToken = null;
        const cm = window.CaptureManager;

        // Bookmark: QUADRANTBOX (this is in two places)
        const quadrantBox = {
            x: 0,
            y: 0,
            width: cm.canvas.width / 2,
            height: cm.canvas.height / 1.5
        };

        return new Promise(async (resolve, reject) => {
            setTimeout(() => {
                console.log("findAndSetInventoryPropertyBox, canvas.width: ", cm.canvas.width, "canvas.height: ", cm.canvas.height);
                console.log("cropping to: ", quadrantBox.width, "x", quadrantBox.height);
                var offscreenCanvas = new OffscreenCanvas(quadrantBox.width, quadrantBox.height);
                var offscreenCtx = offscreenCanvas.getContext('2d');
                let offscreenCanvasNameDetection = null;
                let offscreenCanvasNameDetectionCtx = null;
                if(doBetterNameDetection){
                    offscreenCanvasNameDetection = new OffscreenCanvas(cm.canvas.width / 8, cm.canvas.height / 12);
                    offscreenCanvasNameDetectionCtx = offscreenCanvasNameDetection.getContext('2d');
                }
                
                setTimeout(async () => {
                    try {
                        offscreenCtx.drawImage(cm.videoElement, 0, 0);
                        const firstQuadrantBlob = await offscreenCanvas.convertToBlob();
                        let nameDetectionBlob = null;
                        const formData = new FormData();
                        if(doBetterNameDetection){
                            offscreenCanvasNameDetectionCtx.drawImage(cm.videoElement, 0, 0);
                            nameDetectionBlob = await offscreenCanvasNameDetection.convertToBlob({ type: 'image/png' });
                            const formData2 = new FormData();
                            formData2.append('image', nameDetectionBlob, 'image.png');
                            formData2.append('request-type', 'get-player-name');
                            //   /lifeday/get-player-name
                            const responseName = await fetch('/lifeday/get-player-name', {
                                method: 'POST',
                                headers: {
                                    'Authorization': `Bearer ${RMS.getToken()}`
                                },
                                body: formData2
                            });
                            const dataName = await responseName.json();
                            characterName = dataName.playerName;
                            compToken = dataName.compToken;
                        }
               
                        formData.append('image', firstQuadrantBlob);
                        formData.append('requestType', 'inventory-bounds');

                        const doInvFetch = (token) => fetch('/process-invdata-snap', {
                            method: 'POST',
                            headers: { 'Authorization': `Bearer ${token}` },
                            body: formData
                        });

                        let response = await doInvFetch(compToken || RMS.getToken());

                        if (!compToken && (response.status === 401 || response.status === 403)) {
                            if (await RMS.refreshToken()) {
                                response = await doInvFetch(RMS.getToken());
                            }
                        }

                        const result = await response.json();
                        if (!result.success) throw new Error(result.error);

                        if(compToken)
                            result.compToken = compToken;

                        // Convert API response (boxes with normalized coords [x, y, w, h]) to propertyBox format
                        if(result.boxes && result.boxes.length > 0) {
                            const cropWidth = quadrantBox.width;
                            const cropHeight = quadrantBox.height;
                            // boxes format is [[x, y, w, h]] with normalized coordinates (0-1)
                            const box = result.boxes[0];
                            let [x, y, w, h] = box;
                            console.log("DEBUG: Destructured values - x:", x, "y:", y, "w:", w, "h:", h);

                           

                            const propertyBox = {
                                crop: {
                                    x: Math.round(x * cropWidth),
                                    y: Math.round(y * cropHeight),
                                    width: Math.round(w * cropWidth),
                                    height: Math.round(h * cropHeight)
                                }
                            };

                            console.log("DEBUG: Calculated propertyBox.crop:", propertyBox.crop);
                            cm.setFocusBox(propertyBox.crop);
                            RMS.lastPropertyCrop = propertyBox.crop;

                            const resolveData = {
                                propertyBox: propertyBox,
                                characterName: characterName || result.parsed_content?.find(line => line.startsWith('Name:'))?.replace('Name: ', ''),
                                data: result
                            };
                            console.log("DEBUG: About to resolve with data:", resolveData);
                            resolve(resolveData);
                            console.log("DEBUG: Resolve called");
                        } else {
                            console.error("DEBUG: No boxes found! result.boxes:", result.boxes);
                            reject(new Error('No bounding boxes found in API response'));
                        }
                    } catch (error) {
                        reject(error);
                    }
                }, 100);
            }, 100);
        });
    },
    applyFullScanCaptureData: function() {
        CaptureManager.setCaptureData(() => {
            console.log("DEBUG: setCaptureData, RMS.currentContainer: ", RMS.currentContainer);
            const data = {};
            if (RMS.currentContainer?.id != null) {
                data.containerId = RMS.currentContainer.id;
            }
            return data;
        }, '/process-invdata-snap', (captureData) => {
            if (!captureData?.resource) return;
            if (!RMS.currentContainer) return;
            RMS.currentContainer.resources.push(captureData.resource);
            RMS.addResourceToTable(captureData.resource, "from-process-invdata-snap");
            console.log("DEBUG: captureData: ", captureData);
        });
    },
    restartCaptureMonitoring: function() {
        const cm = window.CaptureManager;
        if (!cm?.focusBox) return;
        cm.startMonitoring(null, () => {
            theQueue.eye([0, 255, 0], 'blinkEye', 200);
            setTimeout(() => theQueue.eye(null, 'rainbowEye'), 250);
        });
    },
    toggleStockMode: function() {
        const cm = window.CaptureManager;
        if (!cm) return;

        if (this.scanMode === 'stock') {
            this.scanMode = 'full';
            this.applyFullScanCaptureData();
            if (this.lastPropertyCrop) {
                cm.setFocusBox(this.lastPropertyCrop);
            } else {
                this.findAndSetInventoryPropertyBox().catch(err => {
                    console.error('Failed to restore inventory property box:', err);
                });
            }
            this.restartCaptureMonitoring();
            theQueue.clear()
                .eye([0, 255, 0], 'pulseEye', 1000)
                .text("Full scan mode restored. Examine resources to catalog them.", 1.5);
        } else {
            this.scanMode = 'stock';
            cm.setCaptureData(() => ({
                requestType: 'stock-update',
                ...(this.currentContainer?.id != null && { containerId: this.currentContainer.id })
            }), '/process-invdata-snap', RMS.handleStockCaptureResult);
            cm.setFocusBox({
                x: 20,
                y: 20,
                width: cm.canvas.width / 2 - 40,
                height: cm.canvas.height / 1.5 - 20
            });
            this.restartCaptureMonitoring();
            theQueue.clear()
                .eye([0, 255, 255], 'pulseEye', 1000)
                .text("Stock mode: hover your resource containers...", 1.5);
        }
        this.updateQuickActions('monitoring');
    },
    handleStockCaptureResult: function(captureData) {
        if (!captureData || captureData.action === 'ignored') return;

        const fmt = (n) => (n != null ? Number(n).toLocaleString() : '?');
        const resource = captureData.resource;

        if (captureData.action === 'updated' && resource) {
            const row = document.querySelector(`tr[data-resource-id="${resource.id}"]`)
                || [...document.querySelectorAll('#resource-table tr[data-resource-name]')]
                    .find(tr => tr.dataset.resourceName?.toLowerCase() === String(resource.name || '').toLowerCase());

            if (row) {
                const qtyCell = row.querySelector('td.quantity');
                if (qtyCell && !qtyCell.querySelector('input')) {
                    qtyCell.textContent = resource.quantity;
                    qtyCell.dataset.rawValue = resource.quantity;
                }
                const lists = [RMS.currentContainer?.resources, RMS.resources].filter(Boolean);
                for (const list of lists) {
                    const existing = list.find(r => r.id === resource.id
                        || r.name?.toLowerCase() === String(resource.name || '').toLowerCase());
                    if (existing) existing.quantity = resource.quantity;
                }
            } else {
                RMS.updateResourcesFromServer();
            }

            theQueue.clear()
                .eye([0, 255, 0], 'pulseEye', 800)
                .text(`*good beeps* ${resource.name}: ${fmt(captureData.previousQuantity)} → ${fmt(resource.quantity)}`, 1.5);
            return;
        }

        if (captureData.action === 'created' && resource) {
            const currentId = RMS.currentContainer?.id;
            if (currentId != null && String(resource.container_id) === String(currentId)) {
                if (!RMS.currentContainer.resources) RMS.currentContainer.resources = [];
                RMS.currentContainer.resources.push(resource);
                RMS.addResourceToTable(resource, 'from-stock-update');
            }
            theQueue.clear()
                .eye([0, 255, 255], 'pulseEye', 800)
                .text(`*curious beeps* New resource stub: ${resource.name} (${fmt(resource.quantity)} units)`, 1.5);
        }
    },
    addResourceToTable: function(resource, source) {


        console.log("DEBUG: addResourceToTable, resource: ", resource, "source: ", source);
        
        // Normalize resource structure: flatten nested qualities object to top level
        // This handles resources coming from OCR parsing (nested) vs database (flat)
        if (resource.qualities && typeof resource.qualities === 'object') {
            const qualityAttributes = [
                'overall_quality',
                'conductivity',
                'cold_resistance',
                'decay_resistance',
                'flavor',
                'heat_resistance',
                'malleability',
                'potential_energy',
                'shock_resistance',
                'unit_toughness',
                'energy_resistance'
            ];
            
            // Copy quality properties from nested object to top level
            // Only copy if they don't already exist at top level (preserve existing values)
            qualityAttributes.forEach(attr => {
                if (resource.qualities[attr] !== undefined && resource[attr] === undefined) {
                    resource[attr] = resource.qualities[attr];
                }
            });
        }
        
        const tbody = document.querySelector('#resource-table tbody');
        const row = document.createElement('tr');
        row.className = 'border-b border-terminal-green/30 hover:bg-terminal-green/10 transition-colors';
        row.dataset.resourceId = resource.id;
        row.dataset.resourceName = resource.name;

        // Define columns and their styling
        const columns = [
            { value: resource.name },
            { value: resource.type },
            {
                value: resource.quantity,
                class: 'quantity editable',
                editable: 'quantity',
                rawValue: resource.quantity
            },
            {
                value: resource.price_per_unit ?
                       resource.price_per_unit.toLocaleString(undefined, {
                           minimumFractionDigits: 0,
                           maximumFractionDigits: 2
                       }) :
                       '-',
                class: `price editable ${getPriceClass(resource.price_per_unit)}`,
                editable: 'price',
                rawValue: resource.price_per_unit || ''
            }
        ];

        // Market PPU column. Spawns that started after the last auction scan were
        // never listed, so fall back to the median for their resource type.
        const marketData = RMS.marketPrices[resource.name?.toLowerCase()]
            || RMS.typePrices?.[resource.type?.toLowerCase()]
            || null;
        columns.push({
            value: marketData ? `${marketData.estimated ? '~' : ''}${marketData.min_ppu.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            })}` : '-',
            class: `market-ppu ${getMarketPriceClass(marketData?.min_ppu)}${marketData?.estimated ? ' market-estimated' : ''}`,
            marketData: marketData
        });

        const addResourceColumn = (value) => {
            columns.push({ value, class: getQualityClass(value) });
        }

        // Add all quality columns in the correct order
        addResourceColumn(resource.overall_quality);
        addResourceColumn(resource.conductivity);
        addResourceColumn(resource.cold_resistance);
        addResourceColumn(resource.heat_resistance);
        addResourceColumn(resource.malleability);
        addResourceColumn(resource.shock_resistance);
        addResourceColumn(resource.unit_toughness);
        addResourceColumn(resource.energy_resistance);
        addResourceColumn(resource.decay_resistance);
        addResourceColumn(resource.potential_energy);
        addResourceColumn(resource.flavor);

        // Create cells
        columns.forEach(column => {
            const cell = document.createElement('td');
            cell.textContent = column.value || '-';
            cell.className = 'p-2 ' + (column.class || '');

            // Make quantity and price cells editable
            if (column.editable) {
                cell.dataset.editType = column.editable;
                cell.dataset.rawValue = column.rawValue;
                cell.style.cursor = 'pointer';
                cell.title = `Click to edit ${column.editable}`;
                cell.onclick = (e) => this.startInlineEdit(e.target, resource);
            }

            // Market PPU tooltip
            if (column.marketData) {
                cell.style.cursor = 'default';
                cell.addEventListener('mouseenter', (e) => showMarketTooltip(e, cell, column.marketData));
                cell.addEventListener('mouseleave', () => hideMarketTooltip());
            }

            row.appendChild(cell);
        });

        // Add action buttons cell (notes + delete)
        const actionCell = document.createElement('td');
        actionCell.className = 'p-2 text-center whitespace-nowrap';

        // Notes button
        const notesBtn = document.createElement('button');
        const hasNotes = resource.notes?.trim();
        notesBtn.innerHTML = hasNotes ? '&#9997;' : '&#128221;'; // Pencil if has notes, empty doc if not
        notesBtn.className = `${hasNotes ? 'text-yellow-400' : 'text-terminal-green/50'} hover:text-terminal-green hover:bg-terminal-green/20 px-1.5 py-0.5 rounded transition-colors text-sm`;
        notesBtn.dataset.resourceId = resource.id;
        notesBtn.dataset.notes = hasNotes || '';
        notesBtn.onclick = () => this.editResourceNotes(resource, notesBtn);
        // Custom tooltip on hover
        notesBtn.addEventListener('mouseenter', (e) => this.showNotesTooltip(e, notesBtn));
        notesBtn.addEventListener('mouseleave', () => this.hideNotesTooltip());
        actionCell.appendChild(notesBtn);

        const recipesBtn = document.createElement('button');
        recipesBtn.textContent = 'R';
        recipesBtn.className = 'text-terminal-green/70 hover:text-terminal-green hover:bg-terminal-green/20 px-1.5 py-0.5 rounded transition-colors text-sm ml-1';
        recipesBtn.title = `Recipes using ${resource.type || resource.name}`;
        recipesBtn.onclick = (e) => {
            e.stopPropagation();
            const query = resource.type || resource.name || '';
            window.open(`/schematics-viewer?uses=${encodeURIComponent(query)}`, '_self');
        };
        actionCell.appendChild(recipesBtn);

        // Delete button
        const deleteBtn = document.createElement('button');
        deleteBtn.textContent = '×';
        deleteBtn.className = 'text-red-500 hover:text-red-300 hover:bg-red-500/20 px-2 py-0.5 rounded transition-colors ml-1';
        deleteBtn.title = 'Delete resource';
        deleteBtn.onclick = () => this.deleteResource(resource, row);
        actionCell.appendChild(deleteBtn);
        row.appendChild(actionCell);

        // Add row to top of table
        tbody.insertBefore(row, tbody.firstChild);

        // Limit table rows
        while (tbody.children.length > 100) {
            tbody.removeChild(tbody.lastChild);
        }
    },

    startInlineEdit: function(cell, resource) {
        // Don't start edit if already editing
        if (cell.querySelector('input')) return;

        const editType = cell.dataset.editType;
        const rawValue = cell.dataset.rawValue;
        const originalText = cell.textContent;

        // Create input
        const input = document.createElement('input');
        input.type = 'number';
        input.value = rawValue || '';
        input.className = 'w-full bg-terminal-dark border border-terminal-green text-terminal-green p-1 text-sm';
        input.style.minWidth = '60px';
        if (editType === 'price') {
            input.step = '0.01';
            input.min = '0';
        } else {
            input.step = '1';
            input.min = '0';
        }

        // Replace text with input
        cell.textContent = '';

        // For quantity editing, create a container with pills
        if (editType === 'quantity') {
            const container = document.createElement('div');
            container.className = 'quantity-edit-container';

            // Create pill buttons above input
            const topPills = document.createElement('div');
            topPills.className = 'quantity-pills quantity-pills-top';
            
            const pillValues = [
                { value: 1000, label: '1k' },
                { value: 10000, label: '10k' },
                { value: 100000, label: '100k' },
                { value: 1000000, label: '1M' }
            ];
            
            pillValues.forEach(({ value, label }) => {
                const pill = document.createElement('button');
                pill.type = 'button';
                pill.className = 'quantity-pill quantity-pill-add';
                pill.textContent = `+${label}`;
                pill.onmousedown = (e) => {
                    e.preventDefault(); // Prevent input blur
                    e.stopPropagation();
                };
                pill.onclick = (e) => {
                    e.stopPropagation();
                    const currentValue = parseFloat(input.value) || 0;
                    input.value = Math.max(0, currentValue + value);
                    // Refocus input after updating value
                    setTimeout(() => input.focus(), 0);
                };
                topPills.appendChild(pill);
            });

            // Create pill buttons below input
            const bottomPills = document.createElement('div');
            bottomPills.className = 'quantity-pills quantity-pills-bottom';
            
            pillValues.forEach(({ value, label }) => {
                const pill = document.createElement('button');
                pill.type = 'button';
                pill.className = 'quantity-pill quantity-pill-subtract';
                pill.textContent = `-${label}`;
                pill.onmousedown = (e) => {
                    e.preventDefault(); // Prevent input blur
                    e.stopPropagation();
                };
                pill.onclick = (e) => {
                    e.stopPropagation();
                    const currentValue = parseFloat(input.value) || 0;
                    input.value = Math.max(0, currentValue - value);
                    // Refocus input after updating value
                    setTimeout(() => input.focus(), 0);
                };
                bottomPills.appendChild(pill);
            });

            container.appendChild(topPills);
            container.appendChild(input);
            container.appendChild(bottomPills);
            cell.appendChild(container);
        } else {
            // For price editing, just add the input directly
            cell.appendChild(input);
        }

        input.focus();
        input.select();

        // Handle save on blur or enter
        const saveEdit = async () => {
            const newValue = parseFloat(input.value);

            // Restore original if invalid or unchanged
            if (isNaN(newValue) || newValue < 0) {
                cell.textContent = originalText;
                return;
            }

            try {
                await this.saveResourceEdit(resource, editType, newValue);

                // Update display
                cell.dataset.rawValue = newValue;
                if (editType === 'price') {
                    cell.textContent = newValue.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                    });
                    // Update price class
                    cell.className = `p-2 price editable ${getPriceClass(newValue)}`;
                } else {
                    cell.textContent = newValue;
                }
                cell.style.cursor = 'pointer';
            } catch (error) {
                console.error('Failed to save edit:', error);
                cell.textContent = originalText;
            }
        };

        input.onblur = saveEdit;
        input.onkeydown = (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                input.blur();
            } else if (e.key === 'Escape') {
                cell.textContent = originalText;
            }
        };
    },

    saveResourceEdit: async function(resource, editType, newValue) {
        const endpoint = editType === 'quantity'
            ? '/api/datachip/resources/modify-quantity'
            : '/api/datachip/resources/modify-price';

        const body = editType === 'quantity'
            ? { resource_id: resource.id, quantity: newValue }
            : { resource_name: resource.name, price_per_unit: newValue };

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.getToken()}`
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error('Failed to save');
        }

        const result = await response.json();
        if (!result.success) {
            throw new Error(result.error || 'Failed to save');
        }

        // Update local resource data
        if (editType === 'quantity') {
            resource.quantity = newValue;
        } else {
            resource.price_per_unit = newValue;
        }

        return result;
    },

    showNotesTooltip: function(event, btn) {
        this.hideNotesTooltip(); // Remove any existing tooltip
        const notes = btn.dataset.notes;
        const hasNotes = notes && notes.trim().length > 0;

        const tooltip = document.createElement('div');
        tooltip.id = 'notes-tooltip';
        tooltip.className = `notes-tooltip ${hasNotes ? 'tooltip-has-note' : 'tooltip-add-note'}`;

        if (hasNotes) {
            // Show note preview (truncate at 100 chars)
            const preview = notes.length > 100 ? notes.substring(0, 100) + '...' : notes;
            tooltip.textContent = preview;
        } else {
            tooltip.textContent = 'Click to add note';
        }

        document.body.appendChild(tooltip);

        // Position above the button
        const rect = btn.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        tooltip.style.left = `${rect.left + (rect.width / 2) - (tooltipRect.width / 2)}px`;
        tooltip.style.top = `${rect.top - tooltipRect.height - 8}px`;

        // Ensure tooltip stays in viewport
        const finalRect = tooltip.getBoundingClientRect();
        if (finalRect.left < 8) {
            tooltip.style.left = '8px';
        } else if (finalRect.right > window.innerWidth - 8) {
            tooltip.style.left = `${window.innerWidth - finalRect.width - 8}px`;
        }
    },

    hideNotesTooltip: function() {
        const tooltip = document.getElementById('notes-tooltip');
        if (tooltip) tooltip.remove();
    },

    editResourceNotes: function(resource, notesBtn) {
        this.hideNotesTooltip(); // Hide tooltip when opening modal
        // Create a simple modal/popup for editing notes
        const existingModal = document.getElementById('notes-edit-modal');
        if (existingModal) existingModal.remove();

        const modal = document.createElement('div');
        modal.id = 'notes-edit-modal';
        modal.className = 'fixed inset-0 bg-black/70 flex items-center justify-center z-50';
        modal.innerHTML = `
            <div class="bg-terminal-dark border border-terminal-green rounded-lg p-4 shadow-terminal-strong max-w-md w-full mx-4">
                <h3 class="text-terminal-green text-lg mb-2">Notes for ${resource.name}</h3>
                <textarea id="notes-textarea" class="w-full h-32 bg-black border border-terminal-green/50 text-terminal-green p-2 rounded resize-none focus:outline-none focus:border-terminal-green" placeholder="Enter notes...">${resource.notes || ''}</textarea>
                <div class="flex justify-end gap-2 mt-3">
                    <button id="notes-cancel" class="px-3 py-1 border border-terminal-green/50 rounded text-terminal-green/70 hover:bg-terminal-green/20">Cancel</button>
                    <button id="notes-save" class="px-3 py-1 bg-terminal-green/20 border border-terminal-green rounded text-terminal-green hover:bg-terminal-green/30">Save</button>
                </div>
            </div>
        `;

        document.body.appendChild(modal);

        const textarea = document.getElementById('notes-textarea');
        const cancelBtn = document.getElementById('notes-cancel');
        const saveBtn = document.getElementById('notes-save');

        textarea.focus();

        const closeModal = () => modal.remove();

        cancelBtn.onclick = closeModal;
        modal.onclick = (e) => { if (e.target === modal) closeModal(); };

        saveBtn.onclick = async () => {
            const newNotes = textarea.value.trim();
            try {
                const response = await fetch('/api/datachip/resources/modify-notes', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.getToken()}`
                    },
                    body: JSON.stringify({ resource_id: resource.id, notes: newNotes || null })
                });

                if (!response.ok) throw new Error('Failed to save notes');

                const result = await response.json();
                if (!result.success) throw new Error(result.error || 'Failed to save notes');

                // Update local resource and button
                resource.notes = newNotes || null;
                notesBtn.innerHTML = newNotes ? '&#9997;' : '&#128221;';
                notesBtn.className = `${newNotes ? 'text-yellow-400' : 'text-terminal-green/50'} hover:text-terminal-green hover:bg-terminal-green/20 px-1.5 py-0.5 rounded transition-colors text-sm`;
                notesBtn.dataset.notes = newNotes || '';

                closeModal();
            } catch (error) {
                console.error('Failed to save notes:', error);
                theQueue.clear()
                    .eye([255, 0, 0], 'strobeEye', 800)
                    .text(`*error beeps* Failed to save notes: ${error.message}`, 2);
            }
        };

        // Handle keyboard
        textarea.onkeydown = (e) => {
            if (e.key === 'Escape') closeModal();
            if (e.key === 'Enter' && e.ctrlKey) saveBtn.click();
        };
    },

    deleteResource: async function(resource, row) {
        try {
            const response = await fetch(`/api/datachip/resources/${resource.id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${this.getToken()}`
                }
            });

            if (!response.ok) {
                throw new Error('Failed to delete');
            }

            const result = await response.json();
            if (!result.success) {
                throw new Error(result.error || 'Failed to delete');
            }

            // Remove from local resources array
            const index = this.resources.findIndex(r => r.id === resource.id);
            if (index > -1) {
                this.resources.splice(index, 1);
            }

            // Remove row from table
            row.remove();

            // Update container indicator
            this.updateContainerIndicator();

            // Show success message
            this.droidQueue.clear()
                .eye([0, 255, 0], 'blinkEye', 1000)
                .text(`*confirmatory beeps* "${resource.name}" deleted.`, 1.5);
        } catch (error) {
            console.error('Failed to delete resource:', error);
            alert('Failed to delete resource');
        }
    },

    importOrExport: async function() {
        const choice = await showImportExportModal();
        if (!choice) return;
        
        if (choice === 'import') {
            const importType = await showImportTypeDialog();
            if (!importType) return;
            
            const csvContent = await showFileUploadDialog();
            if (!csvContent) return;
            
            if (importType === 'pricing') {
                await this.importSWGAideCSVStep2OnlyPricing(csvContent);
            } else {
                await this.importSWGAideCSVStep2ResourcesAndPricing(csvContent);
            }
        } else if (choice === 'export') {
            await this.exportTableToCSV();
        }
    },
    exportTableToCSV: async function() {
        const format = await showExportFormatDialog();
        if (!format) return;
        
        if (format === 'normal') {
            this.exportNormalCSV();
        } else if (format === 'swgaide') {
            await this.exportSWGAideCSVStep1();
        }
    },
    exportNormalCSV: function() {
        const table = document.getElementById('resource-table');
        const rows = Array.from(table.querySelectorAll('tr'));
        
        // Get headers from the first row
        const headers = Array.from(rows[0].querySelectorAll('th')).map(header => header.textContent);
        
        // Get data from remaining rows
        const data = rows.slice(1).map(row => 
            Array.from(row.querySelectorAll('td')).map(cell => cell.textContent)
        );
        
        // Combine headers and data
        const csvContent = [
            headers.join(','),
            ...data.map(row => row.join(','))
        ].join('\n');
        
        // Create and trigger download
        this.downloadCSV(csvContent, 'standard');
    },
    exportSWGAideCSVStep1: async function() {
        const characterName = await showCharacterNameInputDialog();
        if (!characterName) return;
        await this.exportSWGAideCSVStep2(characterName);
    },
    exportSWGAideCSVStep2: async function(characterName) {
        const table = document.getElementById('resource-table');
        const rows = Array.from(table.querySelectorAll('tr')).slice(1); // Skip header row
        const vm = this;

        // Show warning and download option in modal first to get user preferences
        const exportOptions = await new Promise((resolve) => {
            const modal = document.getElementById('import-export-modal');
            modal.classList.remove('hidden');
            modal.classList.add('flex');

            updateImportExportModalContent(
                'Export SWGAide CSV',
                `<p class="mb-4 text-yellow-400">Heads up! This file will replace the data in your SWG Aide.</p>
                <label class="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" id="prepend-container-checkbox" class="w-4 h-4 accent-terminal-green">
                    <span>Prepend each resource note with Container ID</span>
                </label>`,
                [
                    {
                        label: 'Download',
                        onClick: () => {
                            const prependContainer = document.getElementById('prepend-container-checkbox').checked;
                            closeImportExportModal();
                            resolve({ shouldDownload: true, prependContainer });
                        }
                    },
                    {
                        label: 'Cancel',
                        onClick: () => {
                            closeImportExportModal();
                            resolve({ shouldDownload: false, prependContainer: false });
                        }
                    }
                ]
            );
        });

        if (!exportOptions.shouldDownload) return;

        // Create SWGAide format header with comment prefix and comment lines
        const commentLines = [
            '# SWGAide :: Inventory for All @ SWG Legends, file format "CSV" (Comma Separated Values)',
            '# Galaxy/server name is always written to make transfers possible',
            '# Commas are IMPORTANT. Stats and notes are optional.'
        ];
        const header = '# assignee,galaxy,resourceName,ID,resourceClass,classToken,amount,CPU,ER,CR,CD,DR,FL,HR,MA,PE,OQ,SR,UT,notes';

        // Get container ID for notes prefix if enabled
        const containerPrefix = exportOptions.prependContainer && vm.currentContainer
            ? `[${vm.currentContainer.id}] `
            : '';

        // Process each row into SWG Aide format
        const csvRows = rows.map(row => {
            const cells = Array.from(row.querySelectorAll('td'));

            // Map table cells to SWG Aide format (using correct indices)
            const resourceName = cells[0].textContent;  // Name
            const resourceClass = cells[1].textContent; // Type
            const amount = cells[2].textContent;        // Qty
            const price = cells[3].textContent;         // Price (CPU)
            const oq = cells[4].textContent;           // OQ
            const cd = cells[5].textContent;           // CD
            const cr = cells[6].textContent;           // CR
            const hr = cells[7].textContent;           // HR
            const ma = cells[8].textContent;           // MA
            const sr = cells[9].textContent;           // SR
            const ut = cells[10].textContent;          // UT
            const er = cells[11].textContent;          // ER
            const dr = cells[12].textContent;          // DR
            const pe = cells[13].textContent;          // PE
            const fl = cells[14].textContent;          // FL

            // CPU is the cost per unit (price), not conductivity
            const cpu = (price && price !== '-') ? price : '0';
            // Get notes from the notes button's dataset in the last cell
            const notesBtn = row.querySelector('button[data-resource-id]');
            const rawNotes = notesBtn ? (notesBtn.dataset.notes || '') : '';
            const notes = containerPrefix + rawNotes;

            // Helper to convert empty/dash values to 0 for SWGAide compatibility
            const stat = (val) => (val && val !== '-' && val.trim() !== '') ? val : '0';

            // Combine fields in SWG Aide format: ER,CR,CD,DR,FL,HR,MA,PE,OQ,SR,UT
            const classToken = typeof getClassToken === 'function' ? getClassToken(resourceClass) : '';
            return [
                characterName,           // assignee
                'SWG Legends',          // galaxy
                resourceName,           // resourceName
                '',                     // ID (left empty)
                resourceClass,          // resourceClass
                classToken,             // classToken
                amount || '0',          // amount
                cpu,                    // CPU (Cost Per Unit - price)
                stat(er),               // ER (Energy Resistance)
                stat(cr),               // CR (Cold Resistance)
                stat(cd),               // CD (Conductivity)
                stat(dr),               // DR (Decay Resistance)
                stat(fl),               // FL (Flavor)
                stat(hr),               // HR (Heat Resistance)
                stat(ma),               // MA (Malleability)
                stat(pe),               // PE (Potential Energy)
                stat(oq),               // OQ (Overall Quality)
                stat(sr),               // SR (Shock Resistance)
                stat(ut),               // UT (Unit Toughness)
                notes                   // notes
            ].join(',');
        });

        // Combine comment lines, header and data rows
        const csvContent = [...commentLines, header, ...csvRows].join('\n');

        this.downloadCSV(csvContent, 'swgaide', `${characterName}_resources.csv`);
        await showSuccessMessage('Export Complete', `Successfully exported ${csvRows.length} resources as SWGAide CSV.`);
    },
    askForSWGAideCSV: async function(action) {
        const csvContent = await showFileUploadDialog();
        if (csvContent) {
            action(csvContent);
        }
    },
    importSWGAideCSVStep2OnlyPricing: async function(csvContent) {
        let rows = csvContent.split('\n');
        // Remove comment lines (starting with # or "#)
        rows = rows.filter(row => !row.startsWith('#') && !row.startsWith('"#'));
        // Filter out empty rows
        const data = rows.filter(row => row.trim());

        showProcessingMessage(`Found ${data.length} price entries in CSV file...`);

        // Process pricing data from SWGAide format
        // SWGAide CSV format: cells[2] = resourceName, cells[7] = CPU (price)
        const pricingData = [];
        data.forEach(row => {
            if(!row.trim()) return; // Skip empty rows

            const cells = row.split(',');
            if (!cells[2] || !cells[2].trim()) return; // Skip rows without resource name

            const pricing = {
                resource_name: cells[2],                     // resourceName
                price_per_unit: parseFloat(cells[7]) || 0    // CPU (Cost Per Unit)
            };
            if(pricing.price_per_unit > 0) {
                pricingData.push(pricing);
            }
        });
    
        try {
            // Send pricing data to server
            const response = await fetch('/api/datachip/pricing/bulk', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.getToken()}`
                },
                body: JSON.stringify({ pricing: pricingData })
            });
            
            const result = await response.json();
            if (result.success) {
                await showSuccessMessage(
                    'Import Successful',
                    `Successfully imported ${pricingData.length} price entries! Your resource pricing has been updated.`
                );
            } else {
                showErrorMessage('Import Failed', 'Failed to import pricing data to server.');
            }
        } catch (error) {
            showErrorMessage('Import Error', `Error importing pricing data: ${error.message}`);
        }
    },
    importSWGAideCSVStep2ResourcesAndPricing: async function(csvContent) {
        const vm = RMS;
        //scrape the csv file
        let rows = csvContent.split('\n');

        //remove rows starting with # (comment lines and header)
        rows = rows.filter(row => !row.startsWith('#') && !row.startsWith('"'));

        // If first row looks like a header (no data), skip it
        const data = rows.filter(row => row.trim());

        showProcessingMessage(`Found ${data.length} resources in CSV file...`);

        //add the data to the table
        // SWGAide CSV format columns:
        // 0: assignee, 1: galaxy, 2: resourceName, 3: ID, 4: resourceClass, 5: classToken,
        // 6: amount, 7: CPU (price), 8: ER, 9: CR, 10: CD, 11: DR, 12: FL, 13: HR,
        // 14: MA, 15: PE, 16: OQ, 17: SR, 18: UT, 19: notes
        const resources = [];
        data.forEach(row => {
            const cells = row.split(',');
            if (!cells[2] || !cells[2].trim()) return; // Skip rows without resource name

            const resource = {
                name: cells[2],                          // resourceName
                type: cells[4],                          // resourceClass
                quantity: cells[6] || 0,                 // amount
                price_per_unit: cells[7] || 0,           // CPU (Cost Per Unit)
                energy_resistance: cells[8] || 0,        // ER
                cold_resistance: cells[9] || 0,          // CR
                conductivity: cells[10] || 0,            // CD
                decay_resistance: cells[11] || 0,        // DR
                flavor: cells[12] || 0,                  // FL
                heat_resistance: cells[13] || 0,         // HR
                malleability: cells[14] || 0,            // MA
                potential_energy: cells[15] || 0,        // PE
                overall_quality: cells[16] || 0,         // OQ
                shock_resistance: cells[17] || 0,        // SR
                unit_toughness: cells[18] || 0,          // UT
                notes: cells[19]?.trim() || null,        // notes (treat empty/whitespace as null)
            };
            resources.push(resource);
        });
    
        try {
            // Send resources to server
            const response = await fetch('/api/datachip/resources/bulk?'+ new URLSearchParams({
                container: vm.currentContainer.id
            }), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${vm.getToken()}`
                },
                body: JSON.stringify({ resources })
            });
            
            const result = await response.json();
            if (result.success) {
                vm.updateResourcesFromServer();
                const shouldExport = await showSuccessMessage(
                    'Import Successful',
                    `Successfully imported ${resources.length} resources! Would you like to export the updated data back to CSV?`,
                    true
                );
                
                if (shouldExport) {
                    await vm.exportSWGAideCSVStep1();
                }
            } else {
                showErrorMessage('Import Failed', 'Failed to import resources to server.');
            }
        } catch (error) {
            showErrorMessage('Import Error', `Error importing resources: ${error.message}`);
        }
    },
    exportSWGAideCSVStep3: function() {
        const vm = RMS;
        //refresh the table
        vm.updateResourcesFromServer();
    },
    downloadCSV: function(csvContent, format, nameOverride = null) {
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        link.setAttribute('href', url);
        const filename = nameOverride || `resource_data_${format}_${new Date().toISOString().slice(0,10)}.csv`;
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    startCaptureSequence: startCaptureSequence
    
};



//window.addEventListener('resize', resizeCanvas);






// Add function to get JWT token
function getToken() {
    return RMS.datachip.token;
}

// Modify the snapshot processing to include JWT


window.changeFocus = () => {
    CaptureManager.stopMonitoring();
    CaptureManager.setFocusBox(null);
}


function getQualityClass(value) {
    if (!value) return '';
    if (value > 950) return 'text-red-500';
    if (value > 850) return 'text-orange-500';
    if (value > 750) return 'text-yellow-500';
    return 'text-blue-400';
}

// Add new function to validate one-time token
async function validateOneTimeToken(token) {
    try {
        const response = await fetch('/api/validate-token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify({ token })
        });
        
        const data = await response.json();
        return data.success;
    } catch (error) {
        console.error('Token validation error:', error);
        return false;
    }
}

// Quick Actions Management





function showAndSelectContainerModal(){
    showContainerPromptModal().then(container => {
        if (container) {
            selectContainer(container);
        }
    });
}

async function fetchContainersFromServer() {
    try {
        const response = await fetch('/api/datachip/containers', {
            headers: {
                'Authorization': `Bearer ${RMS.getToken()}`
            }
        });
        if (!response.ok) throw new Error('Failed to fetch containers');
        const data = await response.json();
        return data.success ? data.containers : [];
    } catch (error) {
        console.error('Error fetching containers:', error);
        return [];
    }
}


async function showContainerPromptModal() {
    const modal = document.getElementById('container-modal');
    const containerList = document.getElementById('container-list');
    containerList.innerHTML = ''; // Clear existing options

    const containers = await fetchContainersFromServer();

    return new Promise((resolve, reject) => {
        // Render containers (first one is the default - no delete button)
        containers.forEach((container, index) => {
            const isDefault = index === 0;
            const option = document.createElement('div');
            option.className = 'p-3 border border-terminal-green/30 rounded mb-2 ' +
                (RMS.currentContainer?.id === container.id ? 'bg-terminal-green/30' : '');
            const displayName = isDefault ? `${container.name} (Default)` : container.name;
            option.innerHTML = `
                <div class="flex justify-between items-center gap-2">
                    <span class="container-name flex-1 hover:bg-terminal-green/20 cursor-pointer px-1 rounded">${displayName}</span>
                    <span class="text-sm opacity-70">${container.resource_count || 0}</span>
                    <div class="flex gap-1">
                        <button class="import-btn px-1 text-xs border border-terminal-green/30 rounded hover:bg-terminal-green/20">Import</button>
                        <button class="export-btn px-1 text-xs border border-terminal-green/30 rounded hover:bg-terminal-green/20">Export</button>
                        <button class="fix-btn px-1 text-xs border border-orange-500/30 rounded hover:bg-orange-500/20 text-orange-400" title="Fix name/type swaps">Fix</button>
                        ${isDefault ? '' : '<button class="edit-btn px-2 py-1 text-sm border border-terminal-green/30 rounded hover:bg-terminal-green/20" title="Rename">✏️</button>'}
                        ${isDefault ? '' : '<button class="delete-btn px-2 py-1 text-sm border border-red-500/30 rounded hover:bg-red-500/20 text-red-400" title="Delete">🗑️</button>'}
                    </div>
                </div>
            `;

            // Click on name to select
            option.querySelector('.container-name').onclick = (e) => {
                e.stopPropagation();
                closeContainerModal();
                resolve(container);
            };

            // Import button
            option.querySelector('.import-btn').onclick = async (e) => {
                e.stopPropagation();
                closeContainerModal();
                await importToContainer(container);
                const reopened = await showContainerPromptModal();
                resolve(reopened);
            };

            // Export button
            option.querySelector('.export-btn').onclick = async (e) => {
                e.stopPropagation();
                closeContainerModal();
                await exportContainer(container);
                // Re-open modal after export
                const reopened = await showContainerPromptModal();
                resolve(reopened);
            };

            // Fix button - fixes name/type swaps using XML data
            option.querySelector('.fix-btn').onclick = async (e) => {
                e.stopPropagation();
                closeContainerModal();
                await fixContainer(container);
                // Re-open modal after fix
                const reopened = await showContainerPromptModal();
                resolve(reopened);
            };

            // Edit button (not for default container)
            const editBtn = option.querySelector('.edit-btn');
            if (editBtn) {
                editBtn.onclick = async (e) => {
                    e.stopPropagation();
                    closeContainerModal();
                    const updated = await editContainer(container);
                    if (updated) {
                        resolve(updated);
                    } else {
                        // Re-open modal if edit was cancelled
                        const reopened = await showContainerPromptModal();
                        resolve(reopened);
                    }
                };
            }

            // Delete button (not for default container)
            const deleteBtn = option.querySelector('.delete-btn');
            if (deleteBtn) {
                deleteBtn.onclick = async (e) => {
                    e.stopPropagation();
                    const deleted = await deleteContainer(container);
                    if (deleted) {
                        // Refresh the modal
                        containerList.innerHTML = '';
                        closeContainerModal();
                        const reopened = await showContainerPromptModal();
                        resolve(reopened);
                    }
                };
            }

            containerList.appendChild(option);
        });

        modal.classList.remove('hidden');
        modal.classList.add('flex');
    });
}

function closeContainerModal() {
    const modal = document.getElementById('container-modal');
    modal.classList.add('hidden');
    modal.classList.remove('flex');
}

// Import/Export Modal Helper Functions
function closeImportExportModal() {
    const modal = document.getElementById('import-export-modal');
    modal.classList.add('hidden');
    modal.classList.remove('flex');
}

function updateImportExportModalContent(title, contentHTML, buttons) {
    const modal = document.getElementById('import-export-modal');
    const titleEl = document.getElementById('import-export-title');
    const contentEl = document.getElementById('import-export-content');
    const actionsEl = document.getElementById('import-export-actions');
    
    titleEl.textContent = title;
    contentEl.innerHTML = contentHTML;
    
    // Clear existing buttons
    actionsEl.innerHTML = '';
    
    // Add buttons
    if (buttons && buttons.length > 0) {
        buttons.forEach(button => {
            const btn = document.createElement('button');
            btn.textContent = button.label;
            btn.className = button.className || 'border border-terminal-green px-4 py-2 rounded hover:bg-terminal-green/20';
            btn.onclick = button.onClick;
            actionsEl.appendChild(btn);
        });
    } else {
        // Default close button if no buttons provided
        const closeBtn = document.createElement('button');
        closeBtn.textContent = 'Close';
        closeBtn.className = 'border border-terminal-green px-4 py-2 rounded hover:bg-terminal-green/20';
        closeBtn.onclick = closeImportExportModal;
        actionsEl.appendChild(closeBtn);
    }
}

function showImportExportModal() {
    const modal = document.getElementById('import-export-modal');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    
    return new Promise((resolve) => {
        updateImportExportModalContent(
            'Import/Export',
            '<p class="mb-4">Would you like to import from SWG Aide (pricing + resources) or export data?</p>',
            [
                {
                    label: 'Import',
                    onClick: () => {
                        closeImportExportModal();
                        resolve('import');
                    }
                },
                {
                    label: 'Export',
                    onClick: () => {
                        closeImportExportModal();
                        resolve('export');
                    }
                },
                {
                    label: 'Cancel',
                    onClick: () => {
                        closeImportExportModal();
                        resolve(null);
                    }
                }
            ]
        );
    });
}

function showImportTypeDialog(containerName = null) {
    const modal = document.getElementById('import-export-modal');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    
    const message = containerName
        ? `<p class="mb-4">Import to "${containerName}" - what would you like to import?</p>`
        : '<p class="mb-4">Import just pricing or pricing and resources?</p>';
    
    return new Promise((resolve) => {
        updateImportExportModalContent(
            'Import Type',
            message,
            [
                {
                    label: 'Pricing Only',
                    onClick: () => {
                        closeImportExportModal();
                        resolve('pricing');
                    }
                },
                {
                    label: 'Pricing and Resources',
                    onClick: () => {
                        closeImportExportModal();
                        resolve('resources');
                    }
                },
                {
                    label: 'Cancel',
                    onClick: () => {
                        closeImportExportModal();
                        resolve(null);
                    }
                }
            ]
        );
    });
}

function showExportFormatDialog(containerName = null, resourceCount = null) {
    const modal = document.getElementById('import-export-modal');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    
    const message = containerName && resourceCount !== null
        ? `<p class="mb-4">Export "${containerName}" (${resourceCount} resources) - which format?</p>`
        : '<p class="mb-4">Which CSV format would you prefer?</p>';
    
    return new Promise((resolve) => {
        updateImportExportModalContent(
            'Export Format',
            message,
            [
                {
                    label: 'Normal CSV',
                    onClick: () => {
                        closeImportExportModal();
                        resolve('normal');
                    }
                },
                {
                    label: 'SWGAide CSV',
                    onClick: () => {
                        closeImportExportModal();
                        resolve('swgaide');
                    }
                },
                {
                    label: 'Cancel',
                    onClick: () => {
                        closeImportExportModal();
                        resolve(null);
                    }
                }
            ]
        );
    });
}

function showFileUploadDialog() {
    const modal = document.getElementById('import-export-modal');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    
    return new Promise((resolve) => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.csv';
        fileInput.className = 'mb-4';
        fileInput.style.display = 'none';
        
        fileInput.onchange = async (event) => {
            const file = event.target.files[0];
            if (file) {
                try {
                    const csvContent = await file.text();
                    closeImportExportModal();
                    resolve(csvContent);
                } catch (error) {
                    showErrorMessage('Error reading file', error.message);
                    resolve(null);
                }
            } else {
                resolve(null);
            }
        };
        
        updateImportExportModalContent(
            'Upload CSV File',
            '<p class="mb-4">Please upload your SWG Aide CSV file.</p>',
            [
                {
                    label: 'Choose File',
                    onClick: () => {
                        fileInput.click();
                    }
                },
                {
                    label: 'Cancel',
                    onClick: () => {
                        closeImportExportModal();
                        resolve(null);
                    }
                }
            ]
        );
        
        // Add file input to content area
        const contentEl = document.getElementById('import-export-content');
        contentEl.appendChild(fileInput);
    });
}

function showCharacterNameInputDialog() {
    const modal = document.getElementById('import-export-modal');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    
    return new Promise((resolve) => {
        const input = document.createElement('input');
        input.type = 'text';
        input.id = 'character-name-input';
        input.className = 'w-full bg-terminal-dark border border-terminal-green text-terminal-green p-2 rounded mb-4';
        input.placeholder = 'Character name';
        
        updateImportExportModalContent(
            'Character Name',
            '<p class="mb-4">What character name should we export the SWG Aide data as?</p>',
            [
                {
                    label: 'Submit',
                    onClick: () => {
                        const value = input.value.trim();
                        if (value) {
                            closeImportExportModal();
                            resolve(value);
                        }
                    }
                },
                {
                    label: 'Cancel',
                    onClick: () => {
                        closeImportExportModal();
                        resolve(null);
                    }
                }
            ]
        );
        
        // Add input to content area
        const contentEl = document.getElementById('import-export-content');
        contentEl.appendChild(input);
        input.focus();
        
        // Handle Enter key
        input.onkeydown = (e) => {
            if (e.key === 'Enter') {
                const value = input.value.trim();
                if (value) {
                    closeImportExportModal();
                    resolve(value);
                }
            }
        };
    });
}

function showSuccessMessage(title, message, showExportOption = false) {
    const modal = document.getElementById('import-export-modal');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    
    return new Promise((resolve) => {
        const buttons = [
            {
                label: 'Close',
                onClick: () => {
                    closeImportExportModal();
                    resolve(false);
                }
            }
        ];
        
        if (showExportOption) {
            buttons.unshift({
                label: 'Export to CSV',
                onClick: () => {
                    closeImportExportModal();
                    resolve(true);
                }
            });
        }
        
        updateImportExportModalContent(
            title,
            `<p class="mb-4 text-terminal-green">${message}</p>`,
            buttons
        );
    });
}

function showErrorMessage(title, message) {
    const modal = document.getElementById('import-export-modal');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    
    updateImportExportModalContent(
        title,
        `<p class="mb-4 text-red-400">${message}</p>`,
        [
            {
                label: 'Close',
                onClick: closeImportExportModal
            }
        ]
    );
}

function showProcessingMessage(message) {
    const modal = document.getElementById('import-export-modal');
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    
    updateImportExportModalContent(
        'Processing',
        `<p class="mb-4">${message}</p>`,
        []
    );
}

function selectContainer(container) {
    RMS.currentContainer = {
        id: container.id,
        name: container.name,
        notes: container.notes || null,
        resources: [] // Will be populated by updateResourcesFromServer
    };
    closeContainerModal();

    // Update indicator immediately with container name
    RMS.updateContainerIndicator();

    // Refresh resources for the new container (will also update count)
    RMS.updateResourcesFromServer();

    return RMS.currentContainer;
}

async function addNewContainer() {
    closeContainerModal();
    const name = await new Promise(resolve => {
        theQueue.clear()
            .text("*inquisitive beeps* What should we call this container?", 1.5)
            .input("Submit", "container-name", value => resolve(value))
            .eye([0, 255, 255], 'pulseEye', 2000);
            
    });

    if (!name) return null;

    try {
        // Create container on server
        const response = await fetch('/api/datachip/containers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${RMS.getToken()}`
            },
            body: JSON.stringify({ name })
        });

        if (!response.ok) throw new Error('Failed to create container');

        const data = await response.json();
        if (!data.success) throw new Error(data.error || 'Failed to create container');

        theQueue.clear()
            .eye([0, 255, 0], 'blinkEye', 1000)
            .text(`*happy beeps* Container "${name}" created!`, 1.5);

        return data.container;
    } catch (error) {
        console.error('Error creating container:', error);
        theQueue.clear()
            .eye([255, 0, 0], 'strobeEye', 800)
            .text(`*sad beeps* Failed to create container: ${error.message}`, 2);
        return null;
    }
}

async function editContainer(container) {
    const newName = await new Promise(resolve => {
        theQueue.clear()
            .text(`*inquisitive beeps* Rename "${container.name}" to:`, 1.5)
            .eye([0, 255, 255], 'pulseEye', 2000)
            .input("Rename", "container-name", value => resolve(value), container.name);
    });

    if (!newName || newName === container.name) return null;

    try {
        const response = await fetch(`/api/datachip/containers/${container.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${RMS.getToken()}`
            },
            body: JSON.stringify({ name: newName })
        });

        if (!response.ok) throw new Error('Failed to rename container');

        const data = await response.json();
        if (!data.success) throw new Error(data.error || 'Failed to rename container');

        theQueue.clear()
            .eye([0, 255, 0], 'blinkEye', 1000)
            .text(`*happy beeps* Container renamed to "${newName}"!`, 1.5);

        // Update current container if it's the one being edited
        if (RMS.currentContainer?.id === container.id) {
            RMS.currentContainer.name = newName;
        }

        return data.container;
    } catch (error) {
        console.error('Error renaming container:', error);
        theQueue.clear()
            .eye([255, 0, 0], 'strobeEye', 800)
            .text(`*sad beeps* Failed to rename container: ${error.message}`, 2);
        return null;
    }
}

async function deleteContainer(container) {
    closeContainerModal();
    const confirmed = await new Promise(resolve => {
        theQueue.clear()
            .eye([255, 165, 0], 'pulseEye', 1500)
            .text(`*warning beeps* Delete "${container.name}" and all ${container.resource_count || 0} resources inside?`, 2)
            .button("Yes, Delete", () => resolve(true))
            .button("Cancel", () => {
                theQueue.clear()
                    .eye([255, 255, 255], 'blinkEye', 500)
                    .text("*understanding beeps* Cancelled.", 1);
                resolve(false);
            });
    });

    if (!confirmed) return false;

    try {
        const response = await fetch(`/api/datachip/containers/${container.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${RMS.getToken()}`
            }
        });

        if (!response.ok) throw new Error('Failed to delete container');

        const data = await response.json();
        if (!data.success) throw new Error(data.error || 'Failed to delete container');

        theQueue.clear()
            .eye([0, 255, 0], 'blinkEye', 1000)
            .text(`*confirmatory beeps* Container "${container.name}" deleted.`, 1.5);

        // If we deleted the current container, switch to default
        if (RMS.currentContainer?.id === container.id) {
            RMS.currentContainer = {
                id: RMS.datachip.datachip_id,
                name: RMS.datachip.name,
                resources: []
            };
            RMS.updateResourcesFromServer();
        }

        return true;
    } catch (error) {
        console.error('Error deleting container:', error);
        theQueue.clear()
            .eye([255, 0, 0], 'strobeEye', 800)
            .text(`*sad beeps* Failed to delete container: ${error.message}`, 2);
        return false;
    }
}

async function exportContainer(container) {
    try {
        // Fetch resources for this specific container
        const response = await fetch('/api/datachip/resources?' + new URLSearchParams({
            container_id: container.id
        }), {
            headers: {
                'Authorization': `Bearer ${RMS.getToken()}`
            }
        });

        if (!response.ok) throw new Error('Failed to fetch container resources');

        const data = await response.json();
        if (!data.success) throw new Error(data.error || 'Failed to fetch resources');

        const resources = data.resources;

        if (resources.length === 0) {
            showErrorMessage('Export Failed', `Container "${container.name}" is empty, nothing to export.`);
            return;
        }

        // Ask which format to export
        const format = await showExportFormatDialog(container.name, resources.length);
        if (!format) return;

        if (format === 'normal') {
            await exportContainerAsCSV(container, resources, 'normal');
        } else if (format === 'swgaide') {
            await exportContainerAsSWGAide(container, resources);
        }
    } catch (error) {
        console.error('Error exporting container:', error);
        showErrorMessage('Export Failed', `Failed to export: ${error.message}`);
    }
}

async function exportContainerAsCSV(container, resources, format) {
    const headers = ['Name', 'Type', 'Qty', 'Price', 'OQ', 'CD', 'CR', 'HR', 'MA', 'SR', 'UT', 'ER', 'DR', 'PE', 'FL'];

    const rows = resources.map(r => [
        r.name,
        r.type,
        r.quantity || 0,
        r.price_per_unit || '',
        r.overall_quality || '',
        r.conductivity || '',
        r.cold_resistance || '',
        r.heat_resistance || '',
        r.malleability || '',
        r.shock_resistance || '',
        r.unit_toughness || '',
        r.energy_resistance || '',
        r.decay_resistance || '',
        r.potential_energy || '',
        r.flavor || ''
    ].join(','));

    const csvContent = [headers.join(','), ...rows].join('\n');
    const filename = `${container.name.replace(/[^a-z0-9]/gi, '_')}_resources_${new Date().toISOString().slice(0,10)}.csv`;

    RMS.downloadCSV(csvContent, format, filename);

    await showSuccessMessage('Export Complete', `Exported ${resources.length} resources from "${container.name}"!`);
}

async function exportContainerAsSWGAide(container, resources) {
    // Ask for character name
    const characterName = await showCharacterNameInputDialog();
    if (!characterName) return;

    // Show warning and options in modal first
    const exportOptions = await new Promise((resolve) => {
        const modal = document.getElementById('import-export-modal');
        modal.classList.remove('hidden');
        modal.classList.add('flex');

        updateImportExportModalContent(
            'Export SWGAide CSV',
            `<p class="mb-4 text-yellow-400">Heads up! This file will replace the data in your SWG Aide.</p>
            <label class="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" id="prepend-container-checkbox" class="w-4 h-4 accent-terminal-green">
                <span>Prepend each resource note with Container ID</span>
            </label>`,
            [
                {
                    label: 'Download',
                    onClick: () => {
                        const prependContainer = document.getElementById('prepend-container-checkbox').checked;
                        closeImportExportModal();
                        resolve({ shouldDownload: true, prependContainer });
                    }
                },
                {
                    label: 'Cancel',
                    onClick: () => {
                        closeImportExportModal();
                        resolve({ shouldDownload: false, prependContainer: false });
                    }
                }
            ]
        );
    });

    if (!exportOptions.shouldDownload) return;

    // Create SWGAide format header with comment prefix and comment lines
    const commentLines = [
        '# SWGAide :: Inventory for All @ SWG Legends, file format "CSV" (Comma Separated Values)',
        '# Galaxy/server name is always written to make transfers possible',
        '# Commas are IMPORTANT. Stats and notes are optional.'
    ];
    const header = '# assignee,galaxy,resourceName,ID,resourceClass,classToken,amount,CPU,ER,CR,CD,DR,FL,HR,MA,PE,OQ,SR,UT,notes';

    // Get container ID for notes prefix if enabled
    const containerPrefix = exportOptions.prependContainer ? `[${container.id}] ` : '';

    const rows = resources.map(r => {
        // CPU is the cost per unit (price), notes from resource
        const cpu = r.price_per_unit || '0';
        const rawNotes = r.notes || '';
        const notes = containerPrefix + rawNotes;
        const classToken = typeof getClassToken === 'function' ? getClassToken(r.type) : '';
        // Helper to convert empty values to 0 for SWGAide compatibility
        const stat = (val) => (val && val !== 0 && val !== '0') ? val : '0';
        return [
            characterName,
            'SWG Legends',
            r.name,
            '',
            r.type,
            classToken,
            r.quantity || 0,
            cpu,                            // CPU (Cost Per Unit - price)
            stat(r.energy_resistance),      // ER
            stat(r.cold_resistance),        // CR
            stat(r.conductivity),           // CD
            stat(r.decay_resistance),       // DR
            stat(r.flavor),                 // FL
            stat(r.heat_resistance),        // HR
            stat(r.malleability),           // MA
            stat(r.potential_energy),       // PE
            stat(r.overall_quality),        // OQ
            stat(r.shock_resistance),       // SR
            stat(r.unit_toughness),         // UT
            notes
        ].join(',');
    });

    const csvContent = [...commentLines, header, ...rows].join('\n');
    const filename = `${characterName}_${container.name.replace(/[^a-z0-9]/gi, '_')}_resources.csv`;

    RMS.downloadCSV(csvContent, 'swgaide', filename);
    await showSuccessMessage('Export Complete', `Exported ${resources.length} resources from "${container.name}"!`);
}

async function fixContainer(container) {
    try {
        theQueue.clear()
            .eye([255, 165, 0], 'pulseEye', 1000)
            .text(`*processing beeps* Fixing name/type swaps in "${container.name}"...`, 1.5);

        const response = await fetch(`/api/datachip/containers/${container.id}/fix`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${RMS.getToken()}`
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Fix operation failed');
        }

        const data = await response.json();
        if (!data.success) throw new Error(data.error || 'Fix operation failed');

        const correctionCount = data.corrections?.length || 0;

        if (correctionCount === 0) {
            theQueue.clear()
                .eye([255, 255, 0], 'pulseEye', 1000)
                .text(`*satisfied beeps* No corrections needed for "${container.name}". Data looks good!`, 2);
        } else {
            theQueue.clear()
                .eye([0, 255, 0], 'blinkEye', 1000)
                .text(`*happy beeps* Fixed ${correctionCount} resources! Created new container "${data.container.name}" with corrected data.`, 2.5);

            // Log the corrections for debugging
            console.log('Fix corrections:', data.corrections);
        }
    } catch (error) {
        console.error('Error fixing container:', error);
        theQueue.clear()
            .eye([255, 0, 0], 'strobeEye', 800)
            .text(`*sad beeps* Failed to fix container: ${error.message}`, 2);
    }
}

async function importToContainer(container) {
    // Ask what type of import
    const importType = await showImportTypeDialog(container.name);
    if (!importType) return;

    // Open file picker
    const csvContent = await showFileUploadDialog();
    if (!csvContent) return;

    if (importType === 'pricing') {
        await importPricingToContainer(container, csvContent);
    } else {
        await importResourcesToContainer(container, csvContent);
    }
}

async function importPricingToContainer(container, csvContent) {
    let rows = csvContent.split('\n');
    // Remove comment lines (starting with # or "#)
    rows = rows.filter(row => !row.startsWith('#') && !row.startsWith('"#'));
    // Filter out empty rows
    const data = rows.filter(row => row.trim());

    showProcessingMessage(`Found ${data.length} entries in CSV file...`);

    // Process pricing data from SWGAide format
    // SWGAide CSV format: cells[2] = resourceName, cells[7] = CPU (price)
    const pricingData = [];
    data.forEach(row => {
        if (!row.trim()) return;
        const cells = row.split(',');
        if (!cells[2] || !cells[2].trim()) return; // Skip rows without resource name

        const pricing = {
            resource_name: cells[2],                     // resourceName
            price_per_unit: parseFloat(cells[7]) || 0    // CPU (Cost Per Unit)
        };
        if (pricing.price_per_unit > 0) {
            pricingData.push(pricing);
        }
    });

    try {
        const response = await fetch('/api/datachip/pricing/bulk', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${RMS.getToken()}`
            },
            body: JSON.stringify({ pricing: pricingData })
        });

        const result = await response.json();
        if (result.success) {
            // Refresh if this is the current container
            if (RMS.currentContainer?.id === container.id) {
                RMS.updateResourcesFromServer();
            }
            await showSuccessMessage(
                'Import Successful',
                `Imported ${pricingData.length} price entries to "${container.name}"!`
            );
        } else {
            throw new Error(result.error || 'Import failed');
        }
    } catch (error) {
        console.error('Error importing pricing:', error);
        showErrorMessage('Import Failed', `Failed to import pricing: ${error.message}`);
    }
}

async function importResourcesToContainer(container, csvContent) {
    let rows = csvContent.split('\n');
    // Remove comment lines (starting with # or "#)
    rows = rows.filter(row => !row.startsWith('#') && !row.startsWith('"#'));
    // Filter out empty rows
    const data = rows.filter(row => row.trim());

    showProcessingMessage(`Found ${data.length} resources in CSV file...`);

    // Parse resources from SWGAide format
    // SWGAide CSV format columns:
    // 0: assignee, 1: galaxy, 2: resourceName, 3: ID, 4: resourceClass, 5: classToken,
    // 6: amount, 7: CPU (price), 8: ER, 9: CR, 10: CD, 11: DR, 12: FL, 13: HR,
    // 14: MA, 15: PE, 16: OQ, 17: SR, 18: UT, 19: notes
    const resources = [];
    data.forEach(row => {
        if (!row.trim()) return;
        const cells = row.split(',');
        if (!cells[2] || !cells[2].trim()) return; // Skip rows without resource name

        const resource = {
            name: cells[2],                          // resourceName
            type: cells[4],                          // resourceClass
            quantity: cells[6] || 0,                 // amount
            price_per_unit: cells[7] || 0,           // CPU (Cost Per Unit)
            energy_resistance: cells[8] || 0,        // ER
            cold_resistance: cells[9] || 0,          // CR
            conductivity: cells[10] || 0,            // CD
            decay_resistance: cells[11] || 0,        // DR
            flavor: cells[12] || 0,                  // FL
            heat_resistance: cells[13] || 0,         // HR
            malleability: cells[14] || 0,            // MA
            potential_energy: cells[15] || 0,        // PE
            overall_quality: cells[16] || 0,         // OQ
            shock_resistance: cells[17] || 0,        // SR
            unit_toughness: cells[18] || 0,          // UT
            notes: cells[19]?.trim() || null,        // notes (treat empty/whitespace as null)
        };
        resources.push(resource);
    });

    try {
        const response = await fetch('/api/datachip/resources/bulk?' + new URLSearchParams({
            container: container.id
        }), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${RMS.getToken()}`
            },
            body: JSON.stringify({ resources })
        });

        const result = await response.json();
        if (result.success) {
            // Refresh if this is the current container
            if (RMS.currentContainer?.id === container.id) {
                RMS.updateResourcesFromServer();
            }
            await showSuccessMessage(
                'Import Successful',
                `Imported ${resources.length} resources to "${container.name}"!`
            );
        } else {
            throw new Error(result.error || 'Import failed');
        }
    } catch (error) {
        console.error('Error importing resources:', error);
        showErrorMessage('Import Failed', `Failed to import resources: ${error.message}`);
    }
}

async function pauseMonitoringSession() {
    CaptureManager.pauseCapture();
}

async function endMonitoringSession(fromIssue = false, issueMessage = null) {
    // Clean up monitoring - CaptureManager.stopCapture() handles the interval
    CaptureManager.stopCapture();
    RMS.stopWarmupHeartbeat(); // stop keeping the GPU warm; let it scale down naturally

    // Hide the monitor area
    document.getElementById('monitor-area').style.display = 'none';

    // Strict check: only an explicit `true` counts as a failure, so a stray truthy arg (e.g. a click event) can't force the failure ending.
    if(fromIssue === true){
        theQueue
            .eye([255, 0, 0], 'strobeEye', 800)
            .text(`*sad beeps* ${issueMessage || "Monitoring session ended due to an issue. Please try again."}`, 2)
            .wait(100)
            .button("Try Again", startCaptureSequence);
    } else {
        theQueue.clear()
            .eye([0, 255, 0], 'blinkEye')
            .text("*satisfied beeps* Monitoring session ended successfully!<nl>You can now start again anytime.", 2);
    }
    // Update UI

    
    // Update quick actions based on current view
    if(window.location.pathname.startsWith("/lifeday")){
        RMS.updateQuickActions('lifeday');
    } else {
        const isTableVisible = document.getElementById('data-table-container').classList.contains('visible');
        RMS.updateQuickActions(isTableVisible ? 'viewing-table' : 'home');
    }
}

// Add new helper function for session extension
async function handleSessionExtension() {
    theQueue
        .clear()
        .text("Please enter a token to extend the session:", 1.5)
        .input("Submit", "extend-token", async (token) => {
            const response = await fetch('/api/monitoring/extend-session', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify({ token })
            });
            const data = await response.json();
            
            if (data.success) {
                theQueue
                    .eye([0, 255, 0], 'blinkEye', 1000)
                    .text("*happy beeps* Session extended by 30 minutes!", 2)
                    .wait(1000)
                    .text("Starting screen capture...", 1.5);
                RMS.startScreenCapture();
                return true;
            } else {
                theQueue
                    .eye([255, 0, 0], 'strobeEye', 800)
                    .text(`*sad beeps* ${data.error}`, 2)
                    .wait(2000)
                    .button("Try Again", startCaptureSequence);
            }

            return false;
        });
}


function getPriceClass(price) {
    if (!price) return '';
    if (price >= 10) return 'text-red-500';     // 10+ CPU (red)
    if (price >= 5) return 'text-orange-500';   // 5-10 CPU (orange)
    if (price >= 1) return 'text-yellow-500';   // 1-5 CPU (yellow)
    if (price >= 0.5) return 'text-green-400';  // 0.5-1 CPU (green)
    if (price >= 0.1) return 'text-blue-400';   // 0.1-0.5 CPU (blue)
    return 'text-gray-400';                     // < 0.1 CPU (gray)
}

function getMarketPriceClass(price) {
    if (!price) return '';
    if (price >= 13) return 'text-red-500';
    if (price >= 8) return 'text-orange-500';
    if (price >= 1) return 'text-yellow-500';
    if (price >= 0.1) return 'text-green-400';
    return 'text-gray-400';
}

function showMarketTooltip(event, cell, data) {
    hideMarketTooltip();
    const tooltip = document.createElement('div');
    tooltip.id = 'market-tooltip';
    tooltip.className = 'market-tooltip';

    const fmt = (v) => v != null ? v.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) : '-';
    const fmtQty = (v) => v != null ? v.toLocaleString() : '-';

    tooltip.innerHTML = `
        <div class="market-tooltip-title">${data.name}</div>
        <div class="market-tooltip-row">
            <span class="market-tooltip-label">Min PPU</span>
            <span class="${getMarketPriceClass(data.min_ppu)}" style="font-weight:bold">${fmt(data.min_ppu)}</span>
        </div>
        <div class="market-tooltip-row">
            <span class="market-tooltip-label">Avg PPU</span>
            <span>${fmt(data.avg_ppu)}</span>
        </div>
        <div class="market-tooltip-row">
            <span class="market-tooltip-label">Max PPU</span>
            <span>${fmt(data.max_ppu)}</span>
        </div>
        <div class="market-tooltip-divider"></div>
        <div class="market-tooltip-row">
            <span class="market-tooltip-label">Listings</span>
            <span>${data.listing_count}</span>
        </div>
        <div class="market-tooltip-row">
            <span class="market-tooltip-label">Total Qty</span>
            <span>${fmtQty(data.total_quantity)}</span>
        </div>
        ${data.latest_date ? `<div class="market-tooltip-row">
            <span class="market-tooltip-label">Scanned</span>
            <span>${new Date(data.latest_date).toLocaleDateString()}</span>
        </div>` : ''}
    `;

    document.body.appendChild(tooltip);

    const rect = cell.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    tooltip.style.left = `${rect.left + (rect.width / 2) - (tooltipRect.width / 2)}px`;
    tooltip.style.top = `${rect.top - tooltipRect.height - 8}px`;

    // Keep in viewport
    const finalRect = tooltip.getBoundingClientRect();
    if (finalRect.left < 8) {
        tooltip.style.left = '8px';
    } else if (finalRect.right > window.innerWidth - 8) {
        tooltip.style.left = `${window.innerWidth - finalRect.width - 8}px`;
    }
}

function hideMarketTooltip() {
    const tooltip = document.getElementById('market-tooltip');
    if (tooltip) tooltip.remove();
}

// Update the session expiration handling in startCaptureSequence
const startCaptureSequence = async () => {
    RMS.updateQuickActions('monitoring');
    RMS.warmupScanner(); // fire-and-forget: boot the GPU + drive the warm-up progress bar


    //bypass
    theQueue
        .clear()
        .eye([0, 0, 255], 'pulseEye', 1000)
        .text("*happy beeps* Starting screen capture...<nl>(choose the SWG window!)", 1.5);
    setTimeout(RMS.startScreenCapture, 1200);
    return;




    const sessionStatus = await checkActiveSession();
    if (sessionStatus.active) {
        theQueue
            .clear()
            .eye([0, 255, 0], 'blinkEye')
            .text(`*happy beeps* There's an active GPU session started by ${sessionStatus.creator}, with ${sessionStatus.minutesRemaining} minutes remaining.`, 2)

        if (sessionStatus.minutesRemaining < 10) {
            theQueue
                .button("Extend Session (30min)", handleSessionExtension)
                .button("Start Capture", () => {
                    theQueue
                        .clear()
                        .eye([0, 0, 255], 'pulseEye', 1000)
                        .text("*happy beeps* Starting screen capture...<nl>(choose the SWG window!)", 1.5);
                    setTimeout(RMS.startScreenCapture, 1200);
                });
            return;
        }
        
        // Start capture immediately if session is active
        theQueue.wait(1800)
            .eye([0, 0, 255], 'pulseEye', 1000)
            .text("*happy beeps* Starting screen capture...<nl>(choose the SWG window!)", 1.5);
        setTimeout(RMS.startScreenCapture, 1200);
        return;
    }

    // If no active session, proceed with token request
    theQueue
        .clear()
        .eye([0, 255, 255], 'pulseEye', 2000)
        .text("*inquisitive beep* Please enter your RMS GPU Session token:", 1.5)
        .input("Submit", "token-input", async (value) => {
            const isValid = await validateOneTimeToken(value);

            if (isValid) {
                theQueue
                    .eye([0, 255, 0], 'pulseEye', 1000)
                    .text("*happy beeps* Token accepted! Let's begin monitoring.", 2)
                    .wait(2000)
                    .text("Click the button below to start.<nl>(choose the SWG window!)", 2)
                    .button("Start Capture", RMS.startScreenCapture);
                return true;
            } else {
                theQueue
                    .eye([255, 0, 0], 'strobeEye', 800)
                    .text("*sad beeps* Invalid or expired token.<nl>Would you like to try another token?", 1.5)
                    .wait(1000)
                    .eye([0, 255, 255], 'pulseEye', 2000)
                    .button("Try Another Token", RMS.startCaptureSequence)
                    .button("Maybe Later", () => {
                        theQueue
                            .text("*understanding beeps* That's okay! You can still view your stored data.", 2)
                            .eye([255, 255, 0], 'pulseEye', 2000);
                        setTimeout(showResourceTableContainer, 1600);
                    });
                return false;
            }
            return false;
        });
};

// --- Scanner pre-warm ------------------------------------------------------------------
// The Modal GPU scanner scales to zero; a cold start is ~1 min (container boot + model load).
// The moment the user hits Start Capture we fire /api/warmup (server blocks until the GPU is
// warm) and show a ~1-min progress bar that snaps to done the instant warming finishes — so an
// already-warm scanner completes near-instantly. Best-effort: any failure just hides quietly.
let warmupInFlight = false;
let warmupTimer = null;
const WARMUP_EST_SECONDS = 120; // vLLM cold start ≈ 114s (container boot + engine init + weights)

function startWarmupProgress() {
    const area = document.getElementById('warmup-area');
    const bar = document.getElementById('warmup-bar');
    const label = document.getElementById('warmup-label');
    const eta = document.getElementById('warmup-eta');
    if (!area || !bar) return;
    label.textContent = 'Waking up the scanner droid…';
    bar.style.width = '0%';
    area.style.display = 'block';

    const start = Date.now();
    if (warmupTimer) clearInterval(warmupTimer);
    warmupTimer = setInterval(() => {
        const elapsed = (Date.now() - start) / 1000;
        // Ease toward ~95% asymptotically so the bar never "finishes" before the GPU is warm.
        const pct = 95 * (1 - Math.exp(-elapsed / (WARMUP_EST_SECONDS / 2.7)));
        bar.style.width = pct.toFixed(1) + '%';
        if (eta) {
            const remaining = Math.max(0, Math.ceil(WARMUP_EST_SECONDS - elapsed));
            eta.textContent = remaining > 0 ? `~${remaining}s` : 'almost there…';
        }
    }, 400);
}

function finishWarmupProgress(warm, instant) {
    if (warmupTimer) { clearInterval(warmupTimer); warmupTimer = null; }
    const area = document.getElementById('warmup-area');
    const bar = document.getElementById('warmup-bar');
    const label = document.getElementById('warmup-label');
    const eta = document.getElementById('warmup-eta');
    if (instant) {
        if (area) area.style.display = 'none';
        return;
    }
    if (bar && warm) {
        bar.style.width = '100%';
        if (label) label.textContent = 'Scanner ready!';
        if (eta) eta.textContent = '';
    }
    // Hide after a short beat (immediately if it wasn't actually warmed).
    setTimeout(() => { if (area) area.style.display = 'none'; }, warm ? 1200 : 0);
}

const warmupScanner = async () => {
    if (warmupInFlight) return; // guard against double Start Capture clicks
    warmupInFlight = true;
    startWarmupProgress();
    try {
        const res = await fetch('/api/warmup', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${RMS.getToken()}` }
        });
        const data = res.ok ? await res.json().catch(() => ({})) : {};
        RMS.scannerProvider = data.provider || null;
        if (data.provider === 'gemini') {
            finishWarmupProgress(true, true);
        } else {
            finishWarmupProgress(data.warm === true);
        }
    } catch (err) {
        console.warn('Scanner warmup failed (non-fatal):', err);
        finishWarmupProgress(false);
    } finally {
        warmupInFlight = false;
    }
};
RMS.warmupScanner = warmupScanner;

// --- Scanner re-warm heartbeat ---------------------------------------------------------------
// The vLLM scanner container reaps after ~60s idle (scaledown). During a capture session, a
// player can pause for a while between resource windows; without traffic the container goes cold
// and the next scan pays the full ~2min cold start. So while capture is active we ping the warmup
// endpoint every 45s (< the 60s scaledown) to keep the GPU alive. When warm this is a ~0.6s no-op
// (no inference); real scans keep it warm on their own, so this only matters during idle gaps.
// Fire-and-forget; stops when the session ends.
let warmupHeartbeatTimer = null;
const WARMUP_HEARTBEAT_MS = 45000;

function startWarmupHeartbeat() {
    if (RMS.scannerProvider === 'gemini') return; // Gemini has no GPU scaledown
    if (warmupHeartbeatTimer) return; // already running
    warmupHeartbeatTimer = setInterval(() => {
        if (RMS.scannerProvider === 'gemini') {
            stopWarmupHeartbeat();
            return;
        }
        fetch('/api/warmup', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${RMS.getToken()}` }
        }).catch(() => {}); // best-effort; a missed beat just risks one cold scan
    }, WARMUP_HEARTBEAT_MS);
}

function stopWarmupHeartbeat() {
    if (warmupHeartbeatTimer) { clearInterval(warmupHeartbeatTimer); warmupHeartbeatTimer = null; }
}
RMS.startWarmupHeartbeat = startWarmupHeartbeat;
RMS.stopWarmupHeartbeat = stopWarmupHeartbeat;

// Assign to RMS after definition (const isn't hoisted, so the earlier assignment was undefined)
RMS.startCaptureSequence = startCaptureSequence;

// Add new function to toggle resource table
function toggleResourceTable() {
    let dataTableContainer = document.getElementById('data-table-container');
    const isCurrentlyVisible = dataTableContainer.classList.contains('visible');
    
    if (!isCurrentlyVisible) {
        // Show table
        dataTableContainer.style.display = 'block';
        requestAnimationFrame(() => {
            dataTableContainer.classList.add('visible');
            // Update actions after visibility change
            RMS.updateQuickActions(isCurrentlyVisible ? 'home' : 'viewing-table');
        });
    } else {
        // Hide table
        dataTableContainer.classList.remove('visible');
        setTimeout(() => {
            if (!dataTableContainer.classList.contains('visible')) {
                dataTableContainer.style.display = 'none';
            }
            // Update actions after visibility change
            RMS.updateQuickActions(isCurrentlyVisible ? 'home' : 'viewing-table');
        }, 500);
    }
}
// Add new function to check for active session
async function checkActiveSession() {
    try {
        const response = await fetch('/api/monitoring/active-session', {
            headers: {
                'Authorization': `Bearer ${getToken()}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error('Error checking active session:', error);
        return { active: false };
    }
}

// Container dropdown functions
async function toggleContainerDropdown() {
    const dropdown = document.getElementById('container-dropdown');
    const arrow = document.getElementById('dropdown-arrow');
    const isHidden = dropdown.classList.contains('hidden');

    if (isHidden) {
        // Populate and show dropdown
        await populateContainerDropdown();
        dropdown.classList.remove('hidden');
        arrow.style.transform = 'rotate(180deg)';

        // Close dropdown when clicking outside
        setTimeout(() => {
            document.addEventListener('click', closeDropdownOnClickOutside);
        }, 0);
    } else {
        closeContainerDropdown();
    }
}

function closeContainerDropdown() {
    const dropdown = document.getElementById('container-dropdown');
    const arrow = document.getElementById('dropdown-arrow');
    dropdown.classList.add('hidden');
    arrow.style.transform = '';
    document.removeEventListener('click', closeDropdownOnClickOutside);
}

function closeDropdownOnClickOutside(e) {
    const dropdown = document.getElementById('container-dropdown');
    const btn = document.getElementById('container-switch-btn');
    if (!dropdown.contains(e.target) && !btn.contains(e.target)) {
        closeContainerDropdown();
    }
}

async function populateContainerDropdown() {
    const dropdown = document.getElementById('container-dropdown');
    dropdown.innerHTML = '<div class="p-2 text-sm opacity-70">Loading...</div>';

    const containers = await fetchContainersFromServer();

    dropdown.innerHTML = '';

    // Add containers (first one is the default)
    containers.forEach((container, index) => {
        const isDefault = index === 0;
        const displayContainer = isDefault
            ? { ...container, name: `${container.name} (Default)` }
            : container;
        const option = createDropdownOption(displayContainer);
        dropdown.appendChild(option);
    });

    // Add "New Container" option
    const newOption = document.createElement('div');
    newOption.className = 'p-2 text-sm border-t border-terminal-green/30 mt-1 hover:bg-terminal-green/20 cursor-pointer text-center opacity-70';
    newOption.textContent = '+ New Container';
    newOption.onclick = async (e) => {
        e.stopPropagation();
        closeContainerDropdown();
        const newContainer = await addNewContainer();
        if (newContainer) {
            selectContainerFromDropdown(newContainer);
        }
    };
    dropdown.appendChild(newOption);
}

function createDropdownOption(container) {
    const option = document.createElement('div');
    const isSelected = RMS.currentContainer?.id === container.id;
    option.className = `p-2 flex justify-between items-center hover:bg-terminal-green/20 cursor-pointer ${isSelected ? 'bg-terminal-green/30' : ''}`;
    option.innerHTML = `
        <span class="truncate">${container.name}</span>
        <span class="text-xs opacity-50 ml-2">${container.resource_count || 0}</span>
    `;
    option.onclick = (e) => {
        e.stopPropagation();
        selectContainerFromDropdown(container);
    };
    return option;
}

function selectContainerFromDropdown(container) {
    closeContainerDropdown();

    RMS.currentContainer = {
        id: container.id,
        name: container.name,
        notes: container.notes || null,
        resources: []
    };

    // Update indicator immediately
    RMS.updateContainerIndicator();

    // Fetch resources for the new container
    RMS.updateResourcesFromServer();
}

// Expose container functions globally for HTML onclick handlers
window.showAndSelectContainerModal = showAndSelectContainerModal;
window.closeContainerModal = closeContainerModal;

// Share modal functions
async function fetchSharecode(containerId) {
    try {
        const response = await fetch(`/api/datachip/containers/${containerId}/share`, {
            headers: {
                'Authorization': `Bearer ${RMS.getToken()}`
            }
        });
        if (!response.ok) throw new Error('Failed to fetch sharecode');
        const data = await response.json();
        return data.success ? data : null;
    } catch (error) {
        console.error('Error fetching sharecode:', error);
        return null;
    }
}

async function generateSharecode(containerId) {
    try {
        const response = await fetch(`/api/datachip/containers/${containerId}/share`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${RMS.getToken()}`
            }
        });
        if (!response.ok) throw new Error('Failed to generate sharecode');
        const data = await response.json();
        return data.success ? data : null;
    } catch (error) {
        console.error('Error generating sharecode:', error);
        return null;
    }
}

async function revokeSharecode(containerId) {
    try {
        const response = await fetch(`/api/datachip/containers/${containerId}/share`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${RMS.getToken()}`
            }
        });
        if (!response.ok) throw new Error('Failed to revoke sharecode');
        const data = await response.json();
        return data.success;
    } catch (error) {
        console.error('Error revoking sharecode:', error);
        return false;
    }
}

function copyShareUrl(url) {
    navigator.clipboard.writeText(url).then(() => {
        theQueue.clear()
            .eye([0, 255, 0], 'blinkEye', 300)
            .text("*beep* Share URL copied to clipboard!", 1);
    }).catch(err => {
        console.error('Failed to copy:', err);
        theQueue.clear()
            .eye([255, 0, 0], 'blinkEye', 300)
            .text("*error beeps* Failed to copy URL.", 1);
    });
}

function copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
        theQueue.clear()
            .eye([0, 255, 0], 'blinkEye', 300)
            .text("*beep* Copied to clipboard!", 1);
    }).catch(err => {
        console.error('Failed to copy:', err);
        theQueue.clear()
            .eye([255, 0, 0], 'blinkEye', 300)
            .text("*error beeps* Failed to copy.", 1);
    });
}

async function showShareModal() {
    if (!RMS.currentContainer || !RMS.currentContainer.id) {
        theQueue.clear()
            .eye([255, 165, 0], 'blinkEye', 800)
            .text("*warning beeps* Please select a container first.", 1.5);
        return;
    }

    const modal = document.getElementById('share-modal');
    const shareContent = document.getElementById('share-content');
    shareContent.innerHTML = '<p class="opacity-70">Loading...</p>';

    modal.style.display = 'flex';
    modal.classList.remove('hidden');

    // Fetch current sharecode status
    const shareData = await fetchSharecode(RMS.currentContainer.id);

    if (shareData && shareData.sharecode) {
        // Container has a sharecode - show it with regenerate/revoke options
        shareContent.innerHTML = `
            <div class="space-y-4">
                <div>
                    <label class="text-sm opacity-70 mb-1 block">Sharecode:</label>
                    <div class="flex items-center gap-2">
                        <code class="flex-1 p-2 bg-terminal-dark border border-terminal-green/30 rounded text-sm">${shareData.sharecode}</code>
                        <button onclick="copyToClipboard('${shareData.sharecode}')" class="px-2 py-1 text-xs border border-terminal-green/30 rounded hover:bg-terminal-green/20" title="Copy sharecode">📋</button>
                    </div>
                </div>
                <div>
                    <label class="text-sm opacity-70 mb-1 block">Share URL:</label>
                    <div class="flex items-center gap-2">
                        <input type="text" id="share-url-input" readonly value="${shareData.shareUrl}" class="flex-1 p-2 bg-terminal-dark border border-terminal-green/30 rounded text-sm" />
                        <button onclick="copyShareUrl('${shareData.shareUrl}')" class="px-2 py-1 text-xs border border-terminal-green/30 rounded hover:bg-terminal-green/20" title="Copy URL">📋</button>
                    </div>
                </div>
                <div class="flex gap-2 pt-2">
                    <button onclick="regenerateSharecode()" class="flex-1 border border-terminal-green px-4 py-2 rounded hover:bg-terminal-green/20">
                        Regenerate
                    </button>
                    <button onclick="revokeShare()" class="flex-1 border border-red-500/30 px-4 py-2 rounded hover:bg-red-500/20 text-red-400">
                        Revoke
                    </button>
                </div>
            </div>
        `;
    } else {
        // No sharecode - show generate button
        shareContent.innerHTML = `
            <div class="space-y-4">
                <p class="opacity-70">This container is not currently shared. Generate a sharecode to create a shareable link.</p>
                <button onclick="generateNewSharecode()" class="w-full border border-terminal-green px-4 py-2 rounded hover:bg-terminal-green/20">
                    Generate Sharecode
                </button>
            </div>
        `;
    }
}

function closeShareModal() {
    const modal = document.getElementById('share-modal');
    modal.style.display = 'none';
    modal.classList.add('hidden');
}

function escapeAgentHtml(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function showAgentModal() {
    const modal = document.getElementById('agent-modal');
    const content = document.getElementById('agent-modal-content');
    if (!modal || !content) {
        window.location.href = '/agents';
        return;
    }

    const url = `${window.location.origin}/mcp`;
    const token = (RMS.getToken && RMS.getToken()) || '';
    const shown = token || '<jwt from POST /api/auth>';
    const cursorJson = JSON.stringify({
        'c14-rms': {
            type: 'http',
            url,
            headers: { Authorization: `Bearer ${shown}` }
        }
    }, null, 2);
    const claude = `claude mcp add --transport http c14-rms ${url} --header "Authorization: Bearer ${shown}"`;
    window._agentCopy = { url, cursorJson, claude };

    content.innerHTML = `
        <div>
            <label class="text-sm opacity-70 mb-1 block">MCP URL</label>
            <div class="flex items-center gap-2">
                <code class="flex-1 p-2 bg-black/40 border border-terminal-green/30 rounded text-xs break-all">${escapeAgentHtml(url)}</code>
                <button type="button" onclick="copyToClipboard(window._agentCopy.url)" class="px-2 py-1 text-xs border border-terminal-green/30 rounded hover:bg-terminal-green/20">Copy</button>
            </div>
        </div>
        <div>
            <label class="text-sm opacity-70 mb-1 block">Cursor (~/.cursor/mcp.json)</label>
            <pre class="p-2 bg-black/40 border border-terminal-green/30 rounded text-xs whitespace-pre-wrap break-all">${escapeAgentHtml(cursorJson)}</pre>
            <button type="button" onclick="copyToClipboard(window._agentCopy.cursorJson)" class="mt-2 px-3 py-1 text-xs border border-terminal-green rounded hover:bg-terminal-green/20">Copy Cursor config</button>
        </div>
        <div>
            <label class="text-sm opacity-70 mb-1 block">Claude Code</label>
            <pre class="p-2 bg-black/40 border border-terminal-green/30 rounded text-xs whitespace-pre-wrap break-all">${escapeAgentHtml(claude)}</pre>
            <button type="button" onclick="copyToClipboard(window._agentCopy.claude)" class="mt-2 px-3 py-1 text-xs border border-terminal-green rounded hover:bg-terminal-green/20">Copy command</button>
        </div>
        <p class="opacity-70 text-xs">${token
            ? 'This snippet uses your current datachip JWT. Treat it like a password. Tokens last 30 days.'
            : 'No datachip in this browser. Get one on the home page, or point MCP at /mcp with no Authorization and call register_datachip.'}</p>
        <p class="opacity-70 text-xs">Agents that crawl: <a href="/llms.txt" class="underline">/llms.txt</a></p>
    `;

    modal.style.display = 'flex';
    modal.classList.remove('hidden');
}

function closeAgentModal() {
    const modal = document.getElementById('agent-modal');
    if (!modal) return;
    modal.style.display = 'none';
    modal.classList.add('hidden');
}

async function generateNewSharecode() {
    if (!RMS.currentContainer || !RMS.currentContainer.id) return;

    const result = await generateSharecode(RMS.currentContainer.id);
    if (result) {
        // Refresh the modal
        await showShareModal();
        theQueue.clear()
            .eye([0, 255, 0], 'pulseEye', 1000)
            .text("*good beeps* Sharecode generated successfully!", 1.5);
    } else {
        theQueue.clear()
            .eye([255, 0, 0], 'blinkEye', 800)
            .text("*error beeps* Failed to generate sharecode.", 1.5);
    }
}

async function regenerateSharecode() {
    if (!RMS.currentContainer || !RMS.currentContainer.id) return;

    const result = await generateSharecode(RMS.currentContainer.id);
    if (result) {
        // Refresh the modal
        await showShareModal();
        theQueue.clear()
            .eye([0, 255, 0], 'pulseEye', 1000)
            .text("*good beeps* Sharecode regenerated successfully!", 1.5);
    } else {
        theQueue.clear()
            .eye([255, 0, 0], 'blinkEye', 800)
            .text("*error beeps* Failed to regenerate sharecode.", 1.5);
    }
}

async function revokeShare() {
    if (!RMS.currentContainer || !RMS.currentContainer.id) return;

    const confirmed = await new Promise(resolve => {
        theQueue.clear()
            .eye([255, 165, 0], 'blinkEye', 800)
            .text("*warning beeps* Are you sure you want to revoke sharing? This will invalidate the current sharecode.", 2)
            .button("Yes, revoke", () => resolve(true))
            .button("Cancel", () => resolve(false));
    });

    if (!confirmed) return;

    const result = await revokeSharecode(RMS.currentContainer.id);
    if (result) {
        // Refresh the modal
        await showShareModal();
        theQueue.clear()
            .eye([0, 255, 0], 'pulseEye', 1000)
            .text("*beep* Sharing revoked successfully.", 1.5);
    } else {
        theQueue.clear()
            .eye([255, 0, 0], 'blinkEye', 800)
            .text("*error beeps* Failed to revoke sharing.", 1.5);
    }
}

window.showShareModal = showShareModal;
window.closeShareModal = closeShareModal;
window.generateNewSharecode = generateNewSharecode;
window.regenerateSharecode = regenerateSharecode;
window.revokeShare = revokeShare;
window.copyShareUrl = copyShareUrl;
window.copyToClipboard = copyToClipboard;
window.showAgentModal = showAgentModal;
window.closeAgentModal = closeAgentModal;

document.getElementById('agent-modal')?.addEventListener('click', (e) => {
    if (e.target.id === 'agent-modal') closeAgentModal();
});
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAgentModal();
});
window.addNewContainer = addNewContainer;
window.toggleContainerDropdown = toggleContainerDropdown;
window.closeContainerDropdown = closeContainerDropdown;
window.endMonitoringSession = endMonitoringSession;

export { RMS };